{
	"404": {
		"title": "This page doesn't exist",
		"back": "Back to home page",
		"course": "This course doesn't exist, or has been deleted.",
		"organization": "This organization doesn't exist, or has been removed.",
		"post": "This post doesn't exist, or has been removed.",
		"user": "This user doesn't exist.",
		"quiz": "This quiz doesn't exist, or has been deleted.",
		"shareroom": "This classroom doesn't exist, or has been deleted.",
		"group": "This group doesn't exist, or has been deleted.",
		"oops": "Oops!",
		"article": "This insight does not exist or has been deleted.",
		"carousel": "This carousel does not exist or has been deleted.",
		"white_page": {
			"message": "An error has occurred",
			"button": {
				"title": "Please try again"
			}
		}
	},
	"discussion": {
		"edit": {
			"title": "Edit a discussion group."
		},
		"new": {
			"title": "Create a discussion group."
		},
		"name": {
			"placeholder": "Group's name..."
		},
		"description": {
			"placeholder": "Short description..."
		},
		"save": {
			"success": "The group has been saved",
			"error": "An error occured while saving the group"
		},
		"list": {
			"title": "My discussion groups."
		}
	},
	"shareroom": {
		"edit": {
			"title": "Créer une Classroom.",
			"message": "Lay the first brick!   It's simple, give your classroom an identity and make it unique.",
			"add_member": {
				"title": "Add a host and co-hosts"
			},
			"add_members": "You can add up to 3 members to your teaching team",
			"info": {
				"title": "Give your classroom an identity!"
			},
			"banner": {
				"sizing": "{{width}} * {{height}}"
			},
			"cancel_modal": {
				"title": "<< {{name}} >>",
				"big_title": "Are you sure you want to abandon the creative process?",
				"description": "Don't miss out on this great opportunity, reconsider your decision! Create your sanctuary of knowledge and sharing."
			},
			"back": "Back to creation",
			"cancel": "Abandon"
		},
		"new": {
			"title": "Create a Classroom."
		},
		"name": {
			"placeholder": "Classroom's name..."
		},
		"description": {
			"placeholder": "Short description..."
		},
		"save": {
			"success": "The Classroom has been saved",
			"error": "An error occured while saving the shareroom"
		},
		"list": {
			"title": "My Classrooms."
		},
		"workspace": {
			"back": "Back to classroom"
		},
		"workspaces": {
			"title": "Choose a workspace :",
			"limit_reached_modal": {
				"title": "The current version of Jaangal only allows you to have 10 spaces max. ",
				"report": "Notify me when this version is available"
			},
			"request": {
				"sent": "Your request has been sent",
				"error": "Your request has not been sent correctly"
			}
		},
		"administrator": {
			"limit_reached_modal": {
				"title": "You cannot add a new member to the pedadogical team!",
				"description": "Your teaching team has reached the maximum allowed size. Remove existing members to add new ones."
			}
		},
		"cancel_modal": {
			"title": "You can't delete this classroom !"
		},
		"editor": {
			"presentation": {
				"video": {
					"new": "Add a video presentation"
				},
				"text": {
					"placeholder": "Add a description"
				}
			}
		},
		"about": {
			"presentation": {
				"title": "Presentation",
				"owner": {
					"description": "Make your classroom more inviting!\nIt's simple. Tell us about your calling, your motivations, your vision and the benefits to your learners."
				},
				"member": {
					"description": "The trainer has not published the presentation of his classroom yet. Check back later for an update."
				}
			},
			"objective": {
				"title": "Course goals",
				"owner": {
					"description": "Make this space a sanctuary of knowledge!\nTell us about your goals and what learners can gain by subscribing."
				},
				"member": {
					"description": "The trainer has not published the course goals of his classroom yet. Check back later for an update."
				}
			},
			"formatCourse": {
				"title": "Course format",
				"owner": {
					"description": "Deliver your courses the way you want!\nDefine the format and take advantage of our multiple features for more pedagogy."
				},
				"member": {
					"description": "The trainer has not published the course format of his classroom yet. Check back later for an update."
				}
			},
			"schedule": {
				"title": "Course schedule",
				"owner": {
					"description": "Plan ahead! This is the key to success.\nNotify your learners in advance of your class times."
				},
				"member": {
					"description": "The trainer has not published the course schedule of his classroom yet. Check back later for an update."
				}
			},
			"targetAudience": {
				"title": "Target audience",
				"owner": {
					"description": "Give your classroom a dimension!\nTell us who this classroom is for and what is required to subscribe."
				},
				"member": {
					"description": "The trainer has not published the audience of his classroom yet. Check back later for an update."
				}
			},
			"teachers": {
				"title": "Pedagogical team"
			}
		},
		"dashboard": {
			"menu": {
				"title": {
					"GENERAL": "General",
					"DEALING": "Dealings",
					"SETTING": "Settings"
				}
			},
			"check": {
				"title": "Verification",
				"description": "In order to attract the interest of your potential learners, fill in the presentation page of your classroom with more information about the objectives of the course, the schedule, the target audience...",
				"fill_about_page": "Fill \"about\" page"
			},
			"pricing": {
				"title": "Pricing",
				"description": "In this step we let you define the subscription mode of your classroom and its price. ",
				"form": {
					"subscription_mode": {
						"label": "Subsciption mode",
						"MONTHLY": "Monthly",
						"YEARLY": "Annual",
						"UNIQUE": "Unique"
					},
					"subscription_price": "Price",
					"currency": {
						"label": "Currency",
						"XOF": "XOF",
						"EUR": "Euro",
						"USD": "US Dollar ",
						"CHF": "Swiss Franc"
					}
				},
				"update": {
					"forbidden": {
						"message": "You cannot change the price of your classroom when at least one learner has an active subscription.",
						"title": "Update failed"
					}
				}
			},
			"settings": {
				"success": {
					"title": "Monetization activated!",
					"description": "Your target audience can find your classroom and subscribe to it by paying the indicated rate. Share the information to get a lot of learners."
				},
				"sucess": {
					"button": {
						"label": "Return to the dashboard"
					}
				}
			},
			"general": {
				"monetize": {
					"button": {
						"label": "Monetize my classroom"
					},
					"description": "Your knowledge can be monetized! Turn your classroom into a source of earnings. Countless features are waiting for you like this Dashboard which is your dashboard to visualize the evolution reports of your actions during the time. There is only one thing left for you to do, activate the monetization of your classroom by clicking on the button below."
				},
				"income": {
					"title": "My income"
				},
				"reviews": {
					"title": "My reviews"
				},
				"learners": {
					"title": "My learners"
				},
				"info": {
					"income": {
						"title": "Your total income is ...."
					},
					"learners": {
						"title": "Vos apprenants representent ..."
					}
				},
				"all_learners": {
					"title": "Total of learners"
				},
				"audience": {
					"description": "Evolution of your audience as a function of time"
				},
				"recent_learners": {
					"description": "The most recent learners"
				},
				"last_learners": {
					"descrption": "The last learners who joined your classroom"
				}
			},
			"transactions": {
				"info": {
					"reviews": {
						"title": "Your learners' reviews"
					},
					"revenue": {
						"title": "Your total income is ...."
					},
					"balance": {
						"title": "The actual disbursable amount is the amount you can receive on your mobile money."
					}
				},
				"revenue": {
					"title": "My income"
				},
				"balance": {
					"title": "My balance"
				},
				"other": {
					"title": "Other"
				},
				"cashout": {
					"title": "Cash disbursements",
					"null": "You have no subscription for the moment!",
					"description": "You can withdraw your balance at the end of each month."
				},
				"table": {
					"price": {
						"title": "Price classroom"
					},
					"periodicity": {
						"title": "Periodicity",
						"description": "to"
					},
					"balance": {
						"title": "Balance"
					},
					"action": {
						"title": "Action"
					},
					"withdraw_button": {
						"label": "Withdraw"
					},
					"withdrawn_button": {
						"label": "Balance withdrawn"
					},
					"null": "You have no transactions during this period.",
					"object": {
						"title": "Object"
					},
					"date": {
						"title": "Date & Time"
					},
					"mode": {
						"title": "Payment method"
					},
					"amount": {
						"title": "Amount"
					},
					"subscription_mode": {
						"UNIQUE ": "Unique subscription",
						"YEARLY": "Annual subscription",
						"MONTHLY": "Monthly subscription"
					},
					"cashout": {
						"title": "Disbursement"
					}
				},
				"history": {
					"title": "History of your transactions",
					"description": "The last transactions you made"
				}
			}
		},
		"subscription": {
			"summary": {
				"title": "Summary",
				"description": "You wish to join the classroom. We thank you. You are almost there!\n\nIn order to confirm your registration, we invite you to read the details of your subscription and then click on the \"Validate\" button."
			},
			"detail": {
				"title": "Subscription details"
			},
			"classroom": {
				"title": "Title of the classroom : "
			},
			"mode": {
				"title": "Subscription mode :",
				"WEEKLY": "Week",
				"MONTHLY": "Month",
				"YEARLY": "Year",
				"UNIQUE": "Unique"
			},
			"startdate": {
				"title": "Start date :"
			},
			"enddate": {
				"title": "End date :"
			},
			"price": {
				"title": "Subscription price :"
			},
			"title": "Choose the mobile money with which you want to pay your subscription and fill in your phone number. Payment fees will apply depending on the operator chosen.",
			"mobile_money": {
				"title": "Mobile money"
			},
			"phone": {
				"title": "Phone number"
			},
			"progress": {
				"title": "Treatment in progress",
				"description": "Please be patient and follow the instructions you receive."
			},
			"success": {
				"title": "Successful subscription",
				"description": "Your application has been successful."
			},
			"failed": {
				"title": "Subscription failed",
				"description": "Your application has failed."
			},
			"renew": {
				"description": "In one click, renew your subscription to join your classroom and resume your classes!",
				"title": "Renew my subscription"
			},
			"discover": {
				"title": "Discover"
			}
		},
		"operation": {
			"cashout": {
				"description_1": "Do you want to receive the balance of ",
				"description_2": "via your mobile money?",
				"mode": {
					"WV_CH": "Wave",
					"em_CH": "E-Money",
					"OM_CH": "Orange Money",
					"FM_CH": "Free Money",
					"WIZALL": "Wizall"
				},
				"phone": {
					"title": "Phone number"
				}
			},
			"progress": {
				"title": "Treatment in progress",
				"description ": "Please be patient, you will receive your money shortly."
			}
		},
		"delete": {
			"title": "You can't delete this classroom !",
			"description": "When a classroom is monetized and there is at least one member of the classroom who has an active subscription, you are obliged to respect your commitments and continue the training.\nPlease review the monetization conditions of the classroom."
		},
		"guide": {
			"title": "An overview of your classroom",
			"description": "Be the master of your content space.\nOn Jaangal, you have the possibility to monetize your knowledge with a community of enthusiasts. \nTo create your paid classroom, just click on the button below.",
			"dashboard": {
				"message": "Visualize your data",
				"description": "This is your management space. You can set up your classrooms, find the list of your learners, track your payment history and much more!"
			},
			"calendar": {
				"message": "Plan your activities",
				"description": "You are the master of your time. \nIndicate your class times according to your availability to allow our users to join your classroom."
			},
			"live": {
				"message": "Organize videoconference sessions",
				"description": "Live lessons as if you were in the classroom!\n\nWith the upcoming LIVE feature, you will be able to share your knowledge with your learners in a virtual classroom. \nYou will have the possibility to organize instant or scheduled sessions for your classrooms for up to 50 learners per session!"
			},
			"workspaces": {
				"message": "Subdivide your classroom",
				"description": "Set up spaces to organize your activities in small groups. You will gain in efficiency!"
			},
			"activity": {
				"message": "Discuss, share with your learners through the news feed",
				"description": "Shared course materials ? Scheduled live ? New learner? Keep track of your classroom activities."
			}
		},
		"terms": {
			"title": "Conditions of the monetization",
			"intro": "To earn money on our Jaangal platform, you must:",
			"rule_1": "Be of legal age (over 18) at the time of creating your classroom,",
			"rule_2": "Publish authentic content that is yours and not subject to plagiarism or litigation",
			"rule_3": "Respect your commitments in terms of time quantum,",
			"rule_4": "Accept the payment of a 25% commission to Jaangal for each monthly and/or single subscription,",
			"rule_5": "Have a mobile money account for D+30 payments",
			"notice": "Jaangal may suspend or delete any user account that violates the rules of respect and intellectual property.",
			"accept": "I agree to receive information about monetization offers."
		},
		"dashbaord": {
			"general": {
				"chart": {
					"description": "This feature is not yet available."
				}
			},
			"learners": {
				"information_bubble": "Number of learners who have an active subscription."
			},
			"incomes": {
				"information_bubble": "This is the total amount of money you had to collect since the monetization of your classroom."
			},
			"balance": {
				"information_bubble": "This is the amount you can withdraw."
			}
		},
		"premium": {
			"unsubscribtion": "just unsubscribed your classroom "
		},
		"free": {
			"unsubscribtion": "X just left your Y classroom "
		},
		"notification": {
			"post": "just published a post in the classroom ",
			"instant_live ": "just started a live in the classroom ",
			"programmed_live ": "has just scheduled a live in the classroom ",
			"quiz": "has published a quiz in the classroom ",
			"course": "has just published a course in the classroom ",
			"insight": "has just published an insight in the classroom ",
			"review": "left a review on your classroom"
		},
		"review": {
			"infos": "Give your feedback on this classroom",
			"stars": {
				"1": "Disappointing",
				"2": "So so",
				"3": "Good",
				"4": "Great",
				"5": "Excellent !"
			},
			"empty": "There are no reviews for this classroom yet.",
			"placeholder": "Your comment (optional)",
			"title": "{{count}} Reviews",
			"date": "Published {{date}}"
		},
		"add_review": {
			"button": "Add a review"
		},
		"status_change": "made the classroom pay",
		"delete_feedback": {
			"title": "Do you really want to delete this notice?",
			"description": "This is an irreversible action, click on cancel to reverse your decision."
		},
		"role": {
			"ADMINISTRATOR": "Instructor",
			"MEMBER": "Learner",
			"ALL": "All"
		},
		"pdf": {
			"title": "PDF List",
			"empty": "No pdf available"
		}
	},
	"group": {
		"SHAREROOM": {
			"edit": {
				"public": {
					"label": "Public Classroom"
				},
				"title": "Edit your Classroom.",
				"message": "Give an identity to your classroom!",
				"privacy": {
					"label": "Private classroom",
					"infos": "A private classroom won't appear in search results"
				},
				"access": {
					"label": "Open classroom",
					"infos": "An open classroom is accessible by any Jaangal user without admin consent"
				},
				"associate_to_organization": "Associate your Classroom to a school"
			},
			"save": {
				"success": "The Classroom has been saved",
				"error": "An error occured while saving the Classroom"
			},
			"new": {
				"title": "Create your Classroom in 2 steps!"
			},
			"name": {
				"placeholder": "Classroom's name..."
			},
			"description": {
				"placeholder": "Short description..."
			},
			"owner": {
				"title": "Classroom created by"
			},
			"associate_org": {
				"title": "Classroom associated to "
			},
			"toast": {
				"leave": {
					"success": "you successfully left the Classroom"
				},
				"delete": {
					"success": "The Classroom has been removed",
					"error": "An error occured while removing the classroom"
				}
			},
			"categories": {
				"title": "Classroom's discussion topics"
			},
			"members": {
				"list": {
					"empty": "This classroom doesn't have any member yet"
				}
			},
			"join": {
				"success": "You are now a member of the classroom {{name}}"
			},
			"invited": {
				"title": "You have been invited to the Classroom {{name}}"
			},
			"pending": "Your request is pending for validation.",
			"unauthorized": "This Classroom is private. To join, you can make a request.",
			"welcome": "This is an open classroom. You can join by clicking the following button !",
			"delete": {
				"title": "Are you sure you want to delete this classroom?"
			},
			"grant": {
				"success": "The user has been added to the classroom {{name}}",
				"info": "asked to join the classroom."
			},
			"leave": {
				"title": "Are you sure you want to leave this classroom?",
				"message": "You will need to make a new request to access its content."
			},
			"cancel_request": {
				"title": "Are you sure you want to cancel your request to join this classroom ?"
			},
			"role": {
				"ADMINISTRATOR": "Teacher",
				"MEMBER": "Learner"
			},
			"indicative_role": {
				"ADMINISTRATOR": "You are teacher",
				"MEMBER": "You are learner"
			},
			"thumbnail": {
				"members_count": {
					"other": "{{count}} learners",
					"one": "{{count}} learner",
					"zero": "{{count}} learner"
				},
				"admins_count": "{{count}} trainers",
				"animated_by": "Classroom hosted by:"
			},
			"menu": {
				"leave": "Leave this classroom"
			},
			"auth": {
				"incentive": "Join the Classroom {{name}} by signing in"
			},
			"rules": {
				"placeholder": "You can add rules in your Classroom..."
			},
			"thumbnail_badge": "Classroom"
		},
		"banner": {
			"add": "Banner"
		},
		"tab": {
			"activity": "Activity",
			"community": "Members",
			"workspaces": "Workspaces",
			"about": "About",
			"live": "Live",
			"calendar": "Calendar",
			"dashboard": "Dashboard",
			"feedback": "Feedback",
			"pdf": "PDF"
		},
		"edit": {
			"quit": "Cancel edition",
			"add_members": "Add your students and / or members"
		},
		"creation": {
			"quit": "Cancel creation"
		},
		"DISCUSSION_GROUP": {
			"save": {
				"success": "The group has been saved",
				"error": "An error occured while saving the group"
			},
			"edit": {
				"title": "Edit your discussion group.",
				"message": "Give an identity to your discussion group!",
				"privacy": {
					"label": "Private group",
					"infos": "A private discussion won't appear in search results"
				},
				"access": {
					"label": "Open group",
					"infos": "An open discussion group is accessible by any Jaangal user without admin consent"
				},
				"associate_to_organization": "Associate your discussion group to a school"
			},
			"new": {
				"title": "Create your discussion group in 2 steps!"
			},
			"name": {
				"placeholder": "Group's name..."
			},
			"description": {
				"placeholder": "Short description..."
			},
			"owner": {
				"title": "Group created by"
			},
			"associate_org": {
				"title": "Group associated to "
			},
			"toast": {
				"delete": {
					"success": "The group has been removed",
					"error": "An error occured while removing the group"
				},
				"leave": {
					"success": "you successfully left the group"
				},
				"copied_link": "Invitation link copied to clipboard"
			},
			"categories": {
				"title": "Group's discussion topics"
			},
			"members": {
				"list": {
					"empty": "This group doesn't have any member yet"
				}
			},
			"join": {
				"success": "You are now a member of the group {{name}}"
			},
			"invited": {
				"title": "You have been invited to the group {{name}}"
			},
			"pending": "Your request is pending for validation.",
			"unauthorized": "This is a private group. To join it, you can make a request.",
			"welcome": "This is an open group. You can join by clicking the following button !",
			"delete": {
				"title": "Are you sure you want to delete this group?"
			},
			"grant": {
				"success": "The user has been added to the group {{name}}",
				"info": "asked to join the group."
			},
			"leave": {
				"title": "Are you sure you want to leave this group?",
				"message": "You will need to make a new request to access its content."
			},
			"cancel_request": {
				"title": "Are you sure you want to cancel your request to join this group ?"
			},
			"role": {
				"ADMINISTRATOR": "Admin",
				"MEMBER": "Member"
			},
			"indicative_role": {
				"ADMINISTRATOR": "You are admin",
				"MEMBER": "You are member"
			},
			"thumbnail": {
				"members_count": {
					"other": "{{count}} members",
					"one": "{{count}} member",
					"zero": "{{count}} member"
				},
				"admins_count": "{{count}} admins",
				"animated_by": "Led by:"
			},
			"menu": {
				"leave": "Leave this group"
			},
			"auth": {
				"incentive": "Join the group {{name}} by signing in"
			},
			"rules": {
				"placeholder": "You can add rules in your group..."
			},
			"public": {
				"invitation_button": "Invite",
				"copy_link": "Copy invitation link"
			}
		},
		"members": {
			"list": {
				"title": "Members ({{count}})"
			}
		},
		"join": {
			"button": "Join",
			"request": "Ask to join",
			"request_send": "Awaiting acceptance",
			"accept_invitation": "Accept the invitation"
		},
		"request": {
			"success": "Your request has been sent",
			"error": "An error occured while sending your request"
		},
		"grant": {
			"error": "An error occured while adding the user",
			"button": "Approve",
			"modal": {
				"title": "Add a member."
			},
			"accept": "Add {{name}} as:",
			"temporary": "Add {{name}} as:"
		},
		"menu": {
			"cancel_request": "Cancel my request"
		},
		"rules": {
			"button": "Consult the rules of the group",
			"title": "Group rules."
		},
		"edition": {
			"name": "Name",
			"description": "Description",
			"category": "Category",
			"rules": "Group rules"
		},
		"DISCUSSION": {
			"thumbnail_badge": "Discussion group"
		},
		"goback": {
			"organisation": "Go back to school page"
		}
	},
	"social_sharing": {
		"message": "Hello Guys, I found this interesting on Jaangal."
	},
	"app_name": "Jaangal",
	"og_title": "Jaangal - The first african educational social network",
	"logout": "Log out",
	"reset": "Reset",
	"back": "Back",
	"rename": "Rename",
	"add": "Add",
	"edit": "Edit",
	"create": "Create",
	"validate": "Confirm",
	"delete": "Delete",
	"cancel": "Cancel",
	"publish": "Publish",
	"confirm": "Confirm",
	"withdraw": "Withdraw",
	"finish": "Finish",
	"remove": "Remove",
	"save": "Save",
	"quit": "Quit",
	"explore": "Explore",
	"feed-link": "Feed",
	"planete": "Planete",
	"share": "Share",
	"close": "Close",
	"try_again": "Try again",
	"download": "Download ",
	"ignore": "Ignore",
	"subscribe": "Subscribe",
	"discover": "Discover",
	"resubscribe": "Renew your subscription",
	"start": "Start",
	"accept": "Accept",
	"noted": "Noted",
	"donate": "Donate",
	"error_default": "Something went wrong...",
	"error": "Error",
	"success": "Success",
	"add_tags": "Tags separated by a coma (press Enter to confirm)",
	"info": "Information",
	"views": "views",
	"in": "in",
	"coming_soon": "Coming soon",
	"open": "Open",
	"seeAlso": "Similar contents :",
	"see_more": "See more",
	"next": "Next",
	"previous": "Previous",
	"see_less": "See less",
	"more_button": "more",
	"filter_button": "Filter",
	"see_all": "See all",
	"favorite": "Favorite",
	"day": "Day",
	"month": "Month",
	"year": "Year",
	"today": "Today",
	"filter": {
		"SEVENDAYS": "Last 7 days ",
		"THREEMONTHS": "Last 3 months ",
		"SIXMONTHS": "Last 6 months",
		"TWELVEMONTHS": "Last 12 months"
	},
	"date_month_0": "January",
	"date_month_1": "February",
	"date_month_2": "March",
	"date_month_3": "April",
	"date_month_4": "May",
	"date_month_5": "June",
	"date_month_6": "July",
	"date_month_7": "August",
	"date_month_8": "September",
	"date_month_9": "October",
	"date_month_10": "November",
	"date_month_11": "December",
	"short_date_month_0": "Jan",
	"short_date_month_1": "Feb",
	"short_date_month_2": "Mar",
	"short_date_month_3": "Apr",
	"short_date_month_4": "May",
	"short_date_month_5": "June",
	"short_date_month_6": "July",
	"short_date_month_7": "Aug",
	"short_date_month_8": "Sept",
	"short_date_month_9": "Oct",
	"short_date_month_10": "Nov",
	"short_date_month_11": "Dec",
	"short_date_1": "Month",
	"short_date_2": "Tue",
	"short_date_3": "Wed",
	"short_date_4": "Thu",
	"short_date_5": "Fri",
	"short_date_6": "Sat",
	"short_date_7": "Sun",
	"check": "Verify",
	"checked": "Checked",
	"empty_data": "You have no learners at this time.",
	"ok": "Ok",
	"feedback": {
		"date": "Published {{date}}",
		"stars": {
			"1": "Disappointing",
			"2": "So so",
			"3": "Good",
			"4": "Great",
			"5": "Excellent !"
		},
		"placeholder": "Your comment (optional)",
		"title": "Feedback"
	},
	"code": {
		"message": "Didn't you receive the code?",
		"resend": "Resend code"
	},
	"post": {
		"title": "Post",
		"input": {
			"placeholder": "Share with the community",
			"submit": "Publish",
			"image": "Picture"
		},
		"image": {
			"add": "Pictures",
			"edit": "Edit the picture"
		},
		"pdf": {
			"add": "PDF",
			"open": "Open pdf"
		},
		"video": {
			"add": "Video"
		},
		"shared": "shared this 👇🏾",
		"shareroom": {
			"infos": "in {{shareroom}}"
		},
		"application": {
			"published": "invites you to support his application",
			"deleted": "This application is canceled or has been deleted"
		},
		"group": {
			"infos": "in {{group}}",
			"published": "published in",
			"deleted": "This group is private or has been deleted"
		},
		"quiz_published": "published a quiz",
		"published": "published this",
		"shared_self": "You shared ",
		"action": {
			"delete": "Delete",
			"like": "Like",
			"comment": "Comment",
			"reply": "Reply",
			"share": "Repost",
			"share_outside": "Share",
			"share_detail": "Share on my profile"
		},
		"comment": {
			"show": "Show {{count}} comments",
			"more": "See more comments",
			"more_replies": "See more replies",
			"input": {
				"placeholder": "Your comment..."
			},
			"reply": {
				"placeholder": "Your reply...",
				"show": "Show {{count}} replies",
				"show_one": "Show reply"
			}
		},
		"share": {
			"modal": {
				"title": "Share."
			},
			"title": "Shared by:",
			"empty": "This post has not been shared yet."
		},
		"delete": {
			"title": "Are you sure you want to delete this post?"
		},
		"create": {
			"title": "Create a post"
		},
		"edit": {
			"title": "Edit a post",
			"medias": "Add an asset:"
		},
		"course": {
			"deleted": "This course is private or has been deleted by its author"
		},
		"quiz": {
			"deleted": "This quiz is private or has been deleted by its author"
		},
		"post": {
			"deleted": "This post been deleted by its author"
		},
		"organization": {
			"deleted": "This organization has been deleted"
		},
		"live": {
			"deleted": "This live is canceled or has been deleted"
		},
		"delete_comment": {
			"title": "Are you sure you want to delete this comment"
		},
		"likes": {
			"title": "Liked by:",
			"empty": "This post has not been liked yet."
		},
		"comments": {
			"title": "Commented by:",
			"empty": "This post has not been commented yet."
		},
		"target": {
			"default": "On my feed",
			"shareroom": "Share in a Classroom",
			"discussion": "Share in a group"
		},
		"article_published": "published an insight",
		"article": {
			"deleted": "This insight has been deleted by its author"
		},
		"carousel": {
			"deleted": "This carousel has been deleted by its author"
		},
		"carousel_shared": "shared a carousel in ",
		"carousel_published": "published a carousel in ",
		"article_shared": "shared an insight ",
		"course_published": "published a course",
		"course_shared": "shared a course",
		"quiz_shared": "shared a quiz",
		"livecourse_published": "published a live course",
		"livecourse_shared": "shared a live course"
	},
	"sort": "sort",
	"uninterest": "uninterest",
	"welcome": "Welcome on Jaangal",
	"expertise": {
		"english": "English",
		"accounting ": "Accounting",
		"communication": "Communication",
		"community_manager": "Community manager",
		"data_science": "Data science",
		"justice_law": "Law & Justice",
		"entrepreneurship": "Entrepreneurship & leadership",
		"economy": "Economy",
		"finance": "Finance",
		"french": "French",
		"gastronomy": "Gastronomy",
		"project_management": "Project management",
		"graphic_design": "Graphic design",
		"hospitality ": "Hospitality ",
		"real_estate": "Real estate",
		"computer_science": "Computer Science",
		"journalism": "Journalism",
		"literature": "Literature",
		"management": "Management",
		"mathematics": "Mathematics",
		"marketing ": "Marketing",
		"media": "Media",
		"physic_chemistry": "Physics - Chemistry",
		"philosophy": "Philosophy",
		"copywriter ": "Copywriter ",
		"human_and_social_sciences": "Human and Social Sciences",
		"UX_UI_design": "UI/UX design",
		"video_maker": "Videographer - Editor",
		"other": "Other"
	},
	"category": {
		"placeholder": {
			"course": "Course Category ",
			"quiz": "Quiz Category ",
			"article": "Insight Category ",
			"DISCUSSION_GROUP": "Group's main topic",
			"SHAREROOM": "Classroom's main topic"
		},
		"ARTS_AND_CULTURE": "Art & Culture",
		"BUSINESS_AND_MANAGEMENT": "Business & Management",
		"DESIGN": "Design",
		"ENGINEERING": "Engineering",
		"FINANCE_AND_ACCOUNTING": "Finance & Accounting",
		"HEALTH_AND_WELL_BEING": "Health & Wellbeing",
		"INDUSTRY": "Industry",
		"INFORMATION_TECHNOLOGY": "Information Technology",
		"LANGUAGES": "Language Learning",
		"MARKETING": "Marketing & Communication",
		"MATHEMATICS": "Mathematics",
		"SCIENCES": "Sciences",
		"SOCIAL_SCIENCES": "Social Sciences",
		"OTHERS": "Others",
		"ART": "Art",
		"CRAFT": "Arts & Crafts",
		"CULTURE": "Culture",
		"MUSIC": "Music",
		"FITNESS": "Fitness",
		"GLOBAL_HEALTH": "Health",
		"NUTRITION": "Nutrition",
		"SPORT": "Sport",
		"WELL_BEING": "Wellbeing",
		"BIG_DATA": "Big Data & Business Intelligence",
		"DATA_SCIENCE": "Data Sciences",
		"DATABASES": "Database Design & Development",
		"DATABASES_ORACLE": "Database Design & Development - Oracle",
		"DEVOPS": "DevOps",
		"PROGRAMMING_LANGUAGES": "Programming Languages",
		"MOBILE_DEVELOPMENT": "Mobile Development",
		"PRODUCTIVITY": "Productivity",
		"NETWORK_AND_SECURITY": "Network & Security",
		"SYSTEM_ADMINISTRATION": "System Administration",
		"SOFTWARE_TESTING": "Software Testing",
		"WEB_DEVELOPMENT": "Web Development",
		"BRAND_MARKETING": "Brand Marketing",
		"COMMUNICATION": "Communication",
		"CONTENT_MARKETING": "Content Marketing",
		"DIGITAL_MARKETING": "Digital Marketing",
		"OPERATIONAL_MARKETING": "Operational Marketing",
		"PRODUCT_MARKETING": "Product Marketing",
		"SEO": "SEO",
		"SOCIAL_MEDIA_MARKETING": "Social Media Marketing",
		"ACCOUNTING": "Accounting",
		"CRYPTOCURRENCY_AND_BLOCKCHAIN": "Cryptocurrencies & Blockchain",
		"ECONOMY": "Economy",
		"FINANCE": "Finance",
		"FINANCIAL_ANALYSIS": "Financial Analysis",
		"TRADING_AND_INVESTMENTS": "Trading & Investments",
		"DESIGN_THINKING": "Design Thinking",
		"GRAPHIC_MODELING": "Graphic Design & Illustration",
		"MODELING_3D": "3D Conception",
		"UX_DESIGN": "UX Design",
		"BUSINESS_STRATEGY": "Business Strategy",
		"LEADERSHIP": "Entrepreneurship & Leadership",
		"PROJECT_MANAGEMENT": "Project Management",
		"JUSTICE_AND_LAW": "Law & Justice",
		"ANIMAL_HEALTH": "Animal health",
		"HEALTH_INFORMATICS": "Health IT",
		"PSYCHOLOGY": "Psychology",
		"GOVERNANCE_AND_SOCIETY": "Governance and society",
		"ENGLISH": "English",
		"ELECTRICAL_ENGINEERING": "Electrical engineering",
		"MECHANICAL_ENGINEERING": "Mechanical Engineering",
		"EXPERIMENTAL_SCIENCE_AND_SUSTAINABILITY": "Sustainable development",
		"PHYSICS_AND_ASTRONOMY": "Physics and Astronomy",
		"CLOUD": "Nuage",
		"EDUCATION": "Education",
		"SANTE_MENTALE": "Mental Health",
		"MEDIAS": "Media",
		"FRANCAIS": "French",
		"MATHEMATIQUES": "Mathematics",
		"HISTOIRE_GEOGRAPHIE": "History and Geography",
		"EDUCATION_MORALE_ET_CIVIQUE": "Citizenship Education",
		"SCIENCES_DE_LA_VIE_ET_DE_LA_TERRE": "Biology and Geology",
		"PHYSIQUE_CHIMIE": "Physics and Chemistry",
		"LANGUES": "Languages",
		"ARTS": "Arts",
		"EDUCATION_PHYSIQUE_ET_SPORTIVE": "Sports",
		"TECHNOLOGIE_INFORMATIQUE": "Information Technology",
		"SCIENCES_ECONOMIQUES_ET_SOCIALES": "Economics",
		"PHILOSOPHIE": "Philosophy",
		"BIOLOGIE_ECOLOGIE": "Biology and Ecology",
		"COMPTABILITE": "Accounting"
	},
	"kyc": {
		"edit": {
			"modal": {
				"title": "Identification",
				"description": "Please allow us to contact you if we need to.\nFill in your phone number.",
				"title ": "Enter your phone number"
			},
			"user_type": {
				"title": "What is your profile?"
			},
			"PROFESSIONAL": {
				"title": "Professional ",
				"area": "Field of competence"
			},
			"TEACHER": {
				"title": "Teacher",
				"matricule": "Personnel number"
			},
			"lastname": "Last name",
			"firstname": "First name ",
			"email": "Email address",
			"address": "Address",
			"country": "Country of residence ",
			"identity": {
				"type": "Type of identity card",
				"ID": {
					"label": "National identity card"
				},
				"PASSPORT": {
					"label": "Passport"
				},
				"number": "Identity document number",
				"proof_of_identity": {
					"label": "Proof of identity",
					"reminder": "Votre fichier ne doit pas dépasser {{fileSize}}Mb et doit être dans les formats suivants",
					"placeholder": "Upload your proof of identity"
				}
			},
			"phone_number": {
				"verify_link": "Verify",
				"label": "Phone number"
			}
		},
		"verification": {
			"modal": {
				"title": "Verification of the entered phone number",
				"description": "Please enter the code received on the number ending with {{number}}. You did not receive the code?",
				"resend_link": "Send back the code",
				"edit": {
					"otp_code": "OTP validation code"
				},
				"error": {
					"otp_code": "The OTP code you entered is incorrect. Please re-enter it"
				}
			},
			"phone_number": {
				"toast": {
					"success": {
						"message": "The verification of your number was successful"
					},
					"error": {
						"message": "The verification of your number was not successful"
					},
					"resend": {
						"success_title ": "OTP code returned",
						"success_message ": "Please check if you have received the new OTP code by message",
						"error_title": "Error occurred",
						"error_message ": "An error has been noted, we are sending you a new OTP code"
					}
				}
			}
		}
	},
	"asset": {
		"image": "Picture",
		"video": "Video",
		"pdf": "PDF",
		"audio": "Audio",
		"type": {
			"all": "All",
			"IMAGE": "Pictures",
			"VIDEO": "Videos",
			"AUDIO": "Audio",
			"DOCUMENT": "Files"
		},
		"modal": {
			"asset_manager": "Or choose from your Asset Manager"
		},
		"open": "Open"
	},
	"asset_manager": {
		"title": "Asset Manager",
		"mine": {
			"title": "My Asset Manager"
		},
		"upload": {
			"title": "Drop files.",
			"message": "Drag and drop files or click here",
			"message_mobile": "Add files"
		},
		"files": {
			"count": "Your files ({{count}})."
		},
		"search": {
			"placeholder": "Search for an asset...",
			"empty": "There is no file matching your reasearch."
		},
		"empty": "Your asset manager is empty. Upload files to access them quickly.",
		"asset": {
			"add": "Attach to my post"
		},
		"gallery": {
			"error": "This file can not be viewed"
		}
	},
	"video": {
		"quality": {
			"auto": "Auto"
		},
		"transcoding": {
			"error": "An error occured while processing the video",
			"progress": "The video is being processed, this operation may take several minutes ({{progress}}%)"
		}
	},
	"live": {
		"xxx": "",
		"title": "Live Courses",
		"createdby": "Created by",
		"participant": "Participants",
		"create": "Create a live",
		"description": "Start now or schedule a live and chat with other people",
		"instant": "Start an instant video",
		"scheduled": "Start a scheduled video",
		"presentation": "Program your Live easily.",
		"titleplaceholder": "Name your live",
		"notificationwarning": "All students will be notified at launch",
		"autopublish": "Automatically publish a post on the classroom",
		"delete": "Do you really want to delete this live course ?",
		"deletefail": "The live course has not been deleted.",
		"deletesuccess": "Live course successfully deleted !",
		"ongoing": "In progress",
		"upcoming": "Coming Up",
		"members": "Participants",
		"startedat": "Start",
		"from": "from",
		"to": "to",
		"createsuccess": "Live course successfully created !",
		"createfail": "Unable to create a live",
		"threesold": "You have reached the number of lives courses allowed in a classroom",
		"allmembers": "All workspace members ",
		"deleteconfirm": "Do you really want to delete this live course?",
		"justlaunched": "just started a live course",
		"starting": "is live on",
		"inspace": "in the workspace",
		"join": "Join",
		"copylink": "Copy link",
		"joininstantroom": "Participate",
		"start": "Start live",
		"copysuccess": "Copied to clipboard !",
		"copyfailed": "Error copying link",
		"confirmed": "Accepted",
		"declined": "Declined",
		"tobelaunched": "scheduled a live course",
		"closed": "This live course is over",
		"page": {
			"notificationwarning": "All members will be notified at launch",
			"autopublish": "Publish a post on the page"
		},
		"invite": "Invite",
		"invitemembers": "Add other guests",
		"workspace": {
			"autopublish": "Publish a post on the classroom"
		},
		"joinascreator": "Join the live",
		"thumbnail": {
			"badge_label": "Live Course"
		},
		"no_live": "No live has been organized for the moment here",
		"coming_soon": "Lives will be available shortly on the platform!"
	},
	"addDescription": "Add a description",
	"launchLive": "Start live",
	"carousel": {
		"options": {
			"share": "Share",
			"report": "Report",
			"setFav": "Bookmark",
			"title": "Carousel options.",
			"setFullScreen": "View full screen"
		},
		"edit": {
			"title": "Edit carousel",
			"titleCarousel": "Title",
			"category": "Category",
			"language": "Language"
		},
		"delete": {
			"title": "Are you sure you want to delete this carousel?",
			"message": ""
		},
		"post": {
			"checkbox": {
				"label_max_count": "Carousels cannot exceed {{max_count}} pages",
				"labelInfos": "By checking this box, your carousel will be accessible from the search",
				"label": "This is a carousel",
				"label_min_count": "Carousels must have at least {{min_count}} pages"
			},
			"title": {
				"placeholder": "Add a title to your carousel"
			}
		},
		"info_warning": "on Jaangal, a carousel should contain between {{min_slide}} and {{max_slide}} slides.",
		"save": {
			"success": "Carousel saved successfully",
			"error": "Error saving carousel"
		},
		"toast": {
			"delete": {
				"title": "",
				"message": ""
			}
		},
		"insightful": {
			"title": "Click if you find this insightful",
			"tooltip": {
				"labelNotInsightful": "insightful ? ",
				"label": {
					"IfInsightful": "insightful"
				}
			},
			"notification": {
				"label": "{{user}} found your carrousel insightful {{carousel}}. Great !"
			}
		},
		"suggestions": "Carousels by the same author.",
		"detailedView": "Detailed view",
		"auth": {
			"incentive": "Find out other carousels in {{category}} by signing in Jaangal"
		},
		"suggestions_same_category": "Carousels in the same category"
	},
	"seo": {
		"auth": {
			"title": "Jaangal"
		},
		"profile": {
			"title": "{{name}} | Jaangal",
			"picture": "{{name}} profile picture",
			"banner": "{{name}} banner"
		},
		"default": {
			"description": "The first african social network dedicated to online education and knowledge sharing."
		},
		"organization": {
			"title": "{{name}} | Jaangal"
		},
		"group": {
			"DISCUSSION_GROUP": {
				"title": "Group {{name}} | Jaangal"
			},
			"SHAREROOM": {
				"title": "Classroom {{name}} | Jaangal"
			}
		},
		"course": {
			"title": "Course {{name}} | Jaangal"
		},
		"search": {
			"title": "Explore | Jaangal"
		}
	},
	"report": {
		"action": "Report",
		"modal": {
			"title": "Report",
			"message": "Why do you want to report this content?"
		},
		"motive": {
			"FAKE_ACCOUNT": "This is not a real account",
			"IDENTITY_THEFT": "Identity theft",
			"HACKED": "This account has been hacked",
			"SUICIDAL": "This user shares suicidal thoughts",
			"INAPPROPRIATE": "This content is inappropriate",
			"DECEASED": "This user is deceased",
			"CGU": "Violation of the Terms of Service",
			"HATE_SPEECH": "Hate speech",
			"FORBIDDEN_SALES": "Forbidden sales",
			"DANGEROUS_ORGANIZATION": "Dangerous organization",
			"HARASSEMENT": "Harassement",
			"FAKE_NEWS": "Fake news",
			"OTHER": "Other"
		},
		"mail": {
			"subject": "Content report: {{url}}",
			"body": "{{url}}%0D%0A\nI would like to report this content for the following reason: %0D%0A\n{{motive}}"
		},
		"success": "Your report has been sent to the admins",
		"error": "An error occured while sending the report",
		"view": {
			"link": "See content",
			"header": "{{contentType}} reported by:",
			"author": "Content author:",
			"motive": "Motive:",
			"moderate": "Remove content",
			"moderated": "Contenu supprimé"
		},
		"moderate": {
			"title": "Are you sure you want to remove this content ?",
			"message": "This content wont be available on Jaangal anymore. Its author will be notified.",
			"success": "The content has been removed",
			"error": "An error occured while removing the content"
		}
	},
	"workspace": {
		"new": {
			"title": "Create a workspace."
		},
		"edit": {
			"title": "Edit a workspace."
		},
		"name": {
			"placeholder": "Workspace name",
			"default": "General"
		},
		"objective": {
			"placeholder": "Workspace goal"
		},
		"save": {
			"success": "The workspace has been saved",
			"error": "An error occured while saving the workspace"
		},
		"create": "Create a workspace",
		"delete": {
			"title": "Do you really want to delete this workspace ?",
			"message": "Some content may become unreachable.",
			"success": "The workspace has been removed",
			"error": "An error occured while removing the workspace"
		},
		"color": {
			"label": "Choose a color"
		},
		"courses": {
			"title": "Courses ({{count}}).",
			"empty": "This workspace doesn't have any courses yet.",
			"incentive": "Create a course for this workspace",
			"count": {
				"one": "{{count}} course",
				"other": "{{count}} courses",
				"zero": "{{count}} course"
			}
		},
		"quizzes": {
			"title": "Quizzes ({{count}}).",
			"empty": "This workspace doesn't have any quizzes yet.",
			"incentive": "Create a quiz for this workspace",
			"count": {
				"one": "{{count}} quiz",
				"other": "{{count}} quizzes",
				"zero": "{{count}} quiz"
			}
		},
		"articles": {
			"title": "Insight ({{count}}).",
			"empty": "This workspace doesn't have any insight yet.",
			"incentive": "Create a insight for this workspace",
			"count": {
				"one": "{{count}} insight",
				"other": "{{count}} insight",
				"zero": "{{count}} insight"
			}
		},
		"assets": {
			"new": "Add a file",
			"add": "Drag and drop a file or click here to add a new file",
			"title": "Library ({{count}}).",
			"delete": {
				"success": "The file has been deleted",
				"error": "An error occured while deleting the file",
				"title": "Do you really want to delete this file ?"
			},
			"create": {
				"success": "The file has been added to the workspace",
				"error": "An error occured while adding the file",
				"exists": "This file is already available in the Classroom"
			},
			"name": {
				"label": "File name"
			},
			"limit": {
				"error": "You reached the maximum number of files in this workspace"
			},
			"count": {
				"one": "{{count}} file",
				"other": "{{count}} files",
				"zero": "{{count}} document"
			}
		},
		"filter": {
			"title": "Filters.",
			"courses": "Courses",
			"quizzes": "Quizzes",
			"articles": "Insight"
		},
		"size_limit_reached_modal": {
			"title": "You have reached the maximum storage size on this space, try deleting large files and then try again. You can also click on the link below to request more storage.",
			"report": "\nI want to get more storage, notify me when it will be possible"
		},
		"request": {
			"sent": "Your request has been sent",
			"error": "Your request has not been sent correctly"
		}
	},
	"content": {
		"COURSE": "Course",
		"ARTICLE": "Insight",
		"QUIZ": "Quiz",
		"POST": "Post",
		"POST_COMMENT": "Comment",
		"ORGANIZATION": "School",
		"GROUP": "Group",
		"USER": "User",
		"privacy": {
			"warning": "When your content is private, it won't appear in the search results. Furthermore, it must be added to at least one Classroom  before being published.",
			"toggle": "Private content"
		},
		"CAROUSEL": "Carousel"
	},
	"members": {
		"add": {
			"error": "An error occured while adding members"
		},
		"delete": {
			"error": "An error occured while removing member"
		},
		"search": {
			"placeholder": "Search for a member..."
		},
		"role": {
			"CONTRIBUTOR": "Teacher",
			"ADMINISTRATOR": "Admin"
		},
		"CONTRIBUTOR": {
			"add": {
				"title": "Add teachers.",
				"button": "Add teachers",
				"success": "The teachers have successfully been added."
			},
			"delete": {
				"success": "The user has been removed from the teacher list.",
				"title": "Do you really want to remove this teacher?",
				"self": {
					"title": "Do you really want to remove yourself as a teacher ?"
				}
			},
			"list": {
				"title": "Teachers ({{count}})"
			}
		},
		"ADMINISTRATOR": {
			"add": {
				"title": "Add admins.",
				"button": "Add admins",
				"success": "The admins have successfully been added."
			},
			"delete": {
				"success": "The user has been removed from the admin list.",
				"title": "Do you really want to remove this admin?",
				"self": {
					"title": "Do you really want to remove yourself as an admin ?"
				}
			},
			"list": {
				"title": "Admins ({{count}})"
			}
		},
		"SUPER_ADMINISTRATOR": {
			"add": {
				"success": "A new Super Admin have been added."
			}
		},
		"STUDENT": {
			"add": {
				"title": "Invite members.",
				"button": "Invite members",
				"success": "The specified members have been invited"
			},
			"delete": {
				"success": "The user has been removed from the members list.",
				"title": "Are you sure you want to remove that member?"
			}
		},
		"SHAREROOM": {
			"MEMBER": {
				"list": {
					"title": "Learners ({{count}})"
				},
				"add": {
					"title": "Add learners.",
					"button": "Add learners.",
					"success": "The learners have successfully been added."
				},
				"delete": {
					"success": "The user has been removed from the learners list.",
					"title": "Do you really want to remove this learner?"
				}
			},
			"ADMINISTRATOR": {
				"list": {
					"title": "Teachers ({{count}})"
				},
				"add": {
					"title": "Add teachers.",
					"button": "Add teachers",
					"success": "The teachers have successfully been added."
				},
				"delete": {
					"success": "The user has been removed from the teacher list.",
					"title": "Do you really want to remove this teacher?"
				}
			}
		},
		"DISCUSSION_GROUP": {
			"MEMBER": {
				"list": {
					"title": "Members ({{count}})"
				},
				"add": {
					"title": "Add members.",
					"button": "Add members",
					"success": "The members have successfully been added."
				},
				"delete": {
					"success": "The user has been removed from the member list.",
					"title": "Do you really want to remove this member?"
				}
			},
			"ADMINISTRATOR": {
				"list": {
					"title": "Admins ({{count}})"
				},
				"add": {
					"title": "Add admins.",
					"button": "Add admins",
					"success": "The admins have successfully been added."
				},
				"delete": {
					"success": "The user has been removed from the admin list.",
					"title": "Do you really want to remove this admin?"
				}
			}
		},
		"pending": {
			"list": {
				"title": "Pending ({{count}})",
				"accept": "Accept",
				"reject": "Reject",
				"cancel_invitation": "Cancel invitation"
			}
		}
	},
	"quiz": {
		"title": "Quiz.",
		"editor": {
			"title": {
				"placeholder": "Add a title to your quiz..."
			},
			"description": {
				"placeholder": "Add a description here..."
			},
			"category": {
				"placeholder": "Quiz category"
			},
			"level": {
				"placeholder": "Required level of the quiz"
			},
			"header": "Edit a quiz.",
			"new": {
				"header": "Create a quiz."
			},
			"details": {
				"publication": "Publication",
				"settings": "Settings",
				"presentation": "Presentation"
			},
			"step": {
				"back": "Back to editing"
			},
			"subtitle": {
				"EXERCISES": "Create and edit your questions.",
				"PREVIEW": "Your Quiz preview."
			},
			"save": {
				"published": "Save"
			},
			"archive": "Archive this quiz",
			"delete": "Delete this quiz",
			"publish_modal": {
				"title": "Publish your quiz",
				"submit": "Publish my quiz"
			}
		},
		"exercise": {
			"delete": "Delete the question"
		},
		"save": {
			"draft": "Save as draft",
			"success": "Your quiz has been saved."
		},
		"thumbnail": {
			"start": "Take the quiz!",
			"review": "See my answers",
			"participants": {
				"one": "Participant",
				"zero": " No participant",
				"other": "Participants"
			},
			"badge_label": "Quiz"
		},
		"infos": {
			"category": "In: {{category}}",
			"participants": {
				"one": "Participant ({{count}})",
				"zero": "Participant",
				"other": "Participants ({{count}})"
			},
			"questions": "Questions"
		},
		"archive": {
			"success": "Your quiz has been archived."
		},
		"publish": {
			"success": "Your quiz has been published."
		},
		"details": {
			"title": "Details"
		},
		"finished": {
			"title": "Quiz finished !",
			"score": {
				"good": "Congratulations ! You got",
				"bad": "Oh... You only got",
				"particpant": "{{name}} got",
				"value": "{{score}}% good answers.",
				"infos": "Average participants get",
				"average": "a {{score}}% score."
			},
			"share": "Share my score"
		},
		"visibility": {
			"PRIVATE": "Private",
			"PUBLIC": "Public"
		},
		"shared": {
			"score": "I got a {{score}}% score"
		},
		"delete": {
			"title": "Do you really want to delete this content ?",
			"message": "It will not be visible by the community anymore. The attached publication will not be deleted."
		},
		"toast": {
			"delete": {
				"title": "Deletion",
				"message": "Your quiz has been deleted"
			}
		},
		"level": {
			"BEGINNER": "Easy",
			"INTERMEDIATE": "Medium",
			"ADVANCED": "Hard",
			"CLASSE_6EME": "7th grade",
			"CLASSE_5EME": "8th grade",
			"CLASSE_4EME": "9th grade",
			"CLASSE_3EME": "10th grade",
			"CLASSE_2NDE": "11th grade",
			"CLASSE_1ERE": "12th grade",
			"CLASSE_TERMINALE": "13th grade"
		}
	},
	"listing": {
		"more": "{{count}} more..."
	},
	"mobile": {
		"install_app": "Remember to install Jaangal on your home screen!"
	},
	"form": {
		"missing": "This field is mandatory, please fill it in!",
		"invalid": "This information is not valid"
	},
	"language": {
		"FRENCH": "French",
		"ENGLISH": "English",
		"WOLOF": "Wolof",
		"SERERE": "Serer",
		"PULAAR": "Pulaar",
		"DJOLEA": "Diola",
		"BAMBARA": "Bambara",
		"SONINKE": "Soninke",
		"BAOULE": "Baoule",
		"BETE": "Bété",
		"SENOUFO": "Senufo",
		"DIOULA": "Dyula",
		"NOUCHI": "Nouchi"
	},
	"level": {
		"BEGINNER": "Beginner",
		"INTERMEDIATE": "Medium",
		"ADVANCED": "Advanced",
		"none": "No level",
		"CLASSE_6EME": "7th grade",
		"CLASSE_5EME": "8th grade",
		"CLASSE_4EME": "9th grade",
		"CLASSE_3EME": "10th grade",
		"CLASSE_2NDE": "11th grade",
		"CLASSE_1ERE": "12th grade",
		"CLASSE_TERMINALE": "13th grade"
	},
	"login": {
		"presentation": {
			"title": "Welcome to",
			"shortRegisterTitle": "Register",
			"description": "The free, educational social network",
			"baseline": "Jaang ak Khaleyi 🎓"
		},
		"button": {
			"facebook": "Connect with Facebook",
			"google": "Connect with Google",
			"apple": "Connect with Apple",
			"phone": "Connect with Phone",
			"submit": "Sign in",
			"register": "I don't have an account"
		},
		"password": {
			"forgotten": "Forgot password ?"
		},
		"mail": "Or using email:",
		"social": "Sign in with:",
		"title": "Sign in",
		"card": {
			"title": "New on Jaangal ?",
			"description": "Sign Up now and extends your world !\n"
		}
	},
	"auth": {
		"social": {
			"login_after": "or sign in with:",
			"register_after": "or register for free with:",
			"login": "Sign in with:",
			"register": "Register now, it's free!"
		},
		"error": {
			"credentials": "Invalid email or password",
			"exists": "This email is already in use",
			"default": "An error occured"
		},
		"cgu": {
			"modal": {
				"title": "To continue, please accept the Terms of Service"
			}
		},
		"modal": {
			"title": "See more Jaangal content by logging in :"
		},
		"login": {
			"title": "Welcome back",
			"lead": "Sign in to access your space.",
			"switchPrompt": "No account yet?",
			"switchAction": "Sign up"
		},
		"signup": {
			"switchPrompt": "Already have an account?",
			"switchAction": "Sign in",
			"identity": "Sign up",
			"email": "Your email address",
			"emailLead": "A confirmation link will be sent by email.",
			"password": "Your password",
			"passwordHelper": "At least 8 characters, with a letter and a number.",
			"passwordConfirm": "Confirm password",
			"passwordMismatch": "Passwords do not match.",
			"passwordWeak": "Password must be at least 8 characters and include a letter and a number.",
			"continue": "Continue",
			"submit": "Create your account",
			"back": "Back",
			"google": "Sign up with Google",
			"or": "or",
			"phoneTab": "Phone",
			"emailTab": "Email",
			"phoneTitle": "Your phone number",
			"phoneLead": "A verification code will be sent by SMS.",
			"phoneInvalid": "Invalid phone number."
		},
		"hero": {
			"title": "Learn and teach, together.",
			"lead": "Join the education community: courses, resources, help and partner offers, in one place.",
			"members": "+12k",
			"powered": "Powered by Orange"
		},
		"verify": {
			"title": "Check your email",
			"lead": "We sent a confirmation link to {{email}}. Click the link to activate your account.",
			"retry": "Resend the link"
		},
		"role": {
			"title": "Who are you?",
			"lead": "Choose a profile to continue.",
			"learner": "Learner",
			"learnerLead": "I learn and revise",
			"teacher": "Teacher",
			"teacherLead": "I share and teach",
			"parent": "Parent",
			"parentLead": "I support a learner"
		},
		"names": {
			"title": "Your name",
			"lead": "Enter your first and last name."
		},
		"phoneVerify": {
			"title": "Verify your number",
			"lead": "Enter the 6-digit code sent by SMS to {{phone}}.",
			"submit": "Verify",
			"resendPrompt": "Didn't receive anything?",
			"resend": "Resend the code",
			"resendIn": "Resend in {{seconds}} s",
			"invalid": "Invalid code."
		}
	},
	"register": {
		"firstName": {
			"placeholder": "First name"
		},
		"lastName": {
			"placeholder": "Last name"
		},
		"button": {
			"submit": "Sign up now",
			"login": "I already have an account"
		},
		"cgu": {
			"accept": "I've read and accept the ",
			"link": "Terms of Service",
			"missing": "Please accept the Terms of Service"
		},
		"title": "Sign up",
		"rejoin": "Join the Jaangal community !",
		"phonenumber": {
			"title": "Enter your phone number",
			"description": "Enter your phone number, this is the first step in creating your Jaangal account.",
			"placeholder": "Phone number",
			"otp": {
				"description": "Please enter the code received on the number ending with {{lastTwoDigit}}.",
				"title": "Verification of entered phone number",
				"label": "Validation code OTP"
			}
		},
		"social": {
			"login_after": "or sign up with:"
		},
		"modal": {
			"title": "See more Jaangal content by creating account"
		}
	},
	"email": {
		"placeholder": "Email address"
	},
	"password": {
		"weak": "Your password length must be at least {{size}} characters",
		"reset": {
			"success": "You can now use your new password!",
			"title": "Edit your password"
		},
		"new": {
			"label": "New password"
		},
		"confirm": {
			"label": "Password confirmation"
		},
		"forgotten": {
			"title": "Find your password",
			"infos": "Enter your recovery email, then we'll send you a recovery email.",
			"sent": "We are sending you a link for your new password.",
			"button": "Send"
		},
		"placeholder": "Password"
	},
	"navigation": {
		"root": "Home",
		"search": "Search",
		"editor": "Create a course",
		"profile": "Profile",
		"more": "More",
		"create": {
			"title": "What do you want to create?",
			"post": {
				"title": "Post",
				"description": "Share content with your community."
			},
			"quiz": {
				"title": "Quiz",
				"description": "Challenge your friends and community."
			},
			"course": {
				"title": "Course",
				"description": "Share a structured course with your community."
			},
			"discussion": {
				"title": "Discussion group",
				"description": "Create a puplic or a private thematic space."
			},
			"shareroom": {
				"title": "Classroom",
				"description": "Create a private teaching space.",
				"soon": "Availalble soon"
			},
			"article": {
				"title": "Insight",
				"description": "Share a tips, a tutorial or a news with your public."
			}
		},
		"messages": "Messages"
	},
	"home": {
		"header": "Hello, {{name}}",
		"test_feedback": {
			"button": {
				"url": "http://feedback.jaangal.com"
			}
		},
		"new_content": {
			"incentive": "See new content"
		}
	},
	"search": {
		"title": "Search.",
		"input": {
			"placeholder": "Search for courses, profiles..."
		},
		"tab": {
			"course": "Courses",
			"article": "Insights",
			"user": "Profiles",
			"organization": "Organizations"
		},
		"empty": "No results match your search",
		"count": "{{count}} result(s)",
		"COURSE": {
			"count": "{{count}} courses"
		},
		"ARTICLE": {
			"count": "{{count}} insights"
		},
		"QUIZ": {
			"count": "{{count}} quizzes"
		},
		"USER": {
			"count": "{{count}} profiles"
		},
		"COMPANY": {
			"count": "{{count}} companies pages"
		},
		"INSTITUTE": {
			"count": "{{count}} Schools"
		},
		"SHAREROOM": {
			"count": "{{count}} classrooms"
		},
		"DISCUSSION": {
			"count": "{{count}} discussion groups"
		},
		"for": "for",
		"category": "Category",
		"carousel": {
			"suggestion_courses": "Trending Courses",
			"suggestion_articles": "Trending Insights",
			"suggestion_quizzes": "Trending Quizzes",
			"suggestion_users": "Trending Profiles",
			"suggestion_organizations": "Trending Schools",
			"suggestion_sharerooms": "Trending Classrooms",
			"suggestion_discussions": "Trending Groups",
			"carousel": "Trending Carousels",
			"result_courses": "Courses ({{count}})",
			"result_articles": "Insights ({{count}})",
			"result_users": "Profiles ({{count}})",
			"result_quizzes": "Quizzes ({{count}})",
			"result_organizations": "Organizations ({{count}})",
			"result_sharerooms": "Classrooms ({{count}})",
			"result_discussions": "Discussion groups ({{count}})"
		},
		"CAROUSEL": {
			"count": "{{count}} carousels"
		},
		"user": {
			"see_more_categories": "See more"
		},
		"last": {
			"title": "Search history"
		},
		"filter": {
			"type": {
				"title": "Search",
				"all": "All",
				"COURSE": "Courses",
				"ARTICLE": "Insights",
				"QUIZ": "Quizzes",
				"USER": "Profiles",
				"COMPANY": "Company pages",
				"INSTITUTE": "Schools",
				"SHAREROOM": "Classrooms",
				"DISCUSSION": "Discussion groups",
				"CAROUSEL": "Carousels"
			},
			"org_type": {
				"title": "Filter"
			},
			"user_country": {
				"title": "Place of residence"
			},
			"category": {
				"title": "Categories"
			},
			"level": {
				"title": "Level"
			},
			"language": {
				"title": "Language"
			},
			"duration": {
				"title": "Duration",
				"UNKNOWN": "Unknown",
				"MINUTES_0_TO_20": "1 - 20min",
				"MINUTES_20_TO_40": "20 - 40min",
				"MINUTES_40_TO_60": "40min - 1h",
				"MINUTES_MORE_THAN_60": "> 1h"
			},
			"provider": {
				"title": "Provider"
			},
			"license": {
				"title": "License",
				"FREE": "Free",
				"PREMIUM": "Premium"
			},
			"org_subtype": {
				"UNIVERSITY": "University",
				"HIGH_SCHOOL": "High School",
				"MIDDLE_SCHOOL": "Middle School",
				"PROFESSIONAL_TRAINING_CENTER": "Training Center",
				"CERTIFICATION_CENTER": "Certification Center",
				"HIGHER_EDUCATION_INSTITUTE": "Higher Institute",
				"ACADEMY": "Academy",
				"RESEARCH_CENTER": "Research Center",
				"GENERAL_EDUCATION_INSTITUTE": "General Institute",
				"POLYTECHNIC_INSTITUTE": "Polytechnic Institute",
				"NATIONAL_HIGHER_SCHOOL": "National Higher School",
				"ARTIST": "Artist",
				"ASSOCIATION": "Association",
				"NON_PROFIT_ORGANIZATION": "NGO",
				"CHARITABLE_ORGANIZATION": "Charity association",
				"COMMUNITY_ORGANIZATION": "Community organization",
				"INDIVIDUAL_COMPANY": "Individual company",
				"PUBLIC_COMPANY": "Public organization",
				"PRIVATE_COMPANY": "Private organization",
				"PUBLIC_FIGURE": "Public Figure "
			},
			"header": {
				"CONTENT": "CONTENT",
				"PAGES": "PAGES",
				"CHANNELS": "CHANNELS"
			},
			"scoring": {
				"title": "Ranking",
				"most-popular": "The most famous"
			},
			"rating": {
				"title": "Rating"
			}
		},
		"ORGANIZATION": {
			"count": "{{count}} organizations"
		}
	},
	"profile": {
		"tab": {
			"post": "Activity",
			"post_self": "My activity",
			"favorite": "My favorites",
			"course_self": "My courses",
			"course": "Courses",
			"content_self": "My content",
			"content": "Content",
			"groups": "My Classrooms"
		},
		"content_self": {
			"courses": "My courses",
			"articles": "My insights",
			"quizzes": "My quizzes",
			"carousels": "My carousels"
		},
		"content": {
			"courses": "Courses",
			"articles": "Insights",
			"quizzes": "Quizzes",
			"carousels": "Carousels",
			"published": {
				"zero": "no published content ",
				"one": "{{count}}  published content",
				"other": "{{count}} published content"
			},
			"PREMIUM": "Premium",
			"FREE": "Free"
		},
		"course_self": {
			"empty": "You have no such course.",
			"empty_all": "You haven't created any courses."
		},
		"article_self": {
			"empty": "You have no such insight.",
			"empty_all": "You haven't created any insights."
		},
		"quiz_self": {
			"empty": "You have no such quiz.",
			"empty_all": "You haven't created any quizzes."
		},
		"courses": {
			"empty": "{{user}} hasn't created any courses.",
			"published": {
				"zero": "No published course",
				"one": "{{count}} published course",
				"other": "{{count}} published courses"
			}
		},
		"articles": {
			"empty": "{{user}} hasn't created any insights."
		},
		"quizzes": {
			"empty": "{{user}} hasn't created any quizzes."
		},
		"favorite": {
			"empty": "You do not have any content in your favorites yet. Pin the ones that interest you to easily find them here!"
		},
		"card": {
			"quick_edit": "Edit my profile",
			"description": {
				"add": "Add a title to your profile",
				"cancel": "Cancel",
				"confirm": "Save"
			},
			"follower": "is following you",
			"followers": "Followers",
			"followees": "Following",
			"categories": {
				"see_more": " + See more",
				"see_less": " - See less"
			},
			"member_since": "Member since ",
			"invite": {
				"title": "Invite friends to join Jaangal",
				"message": "I invite you to join Jaangal",
				"action": {
					"send_invitation_button_label": "Invite",
					"email_invalid_toast": "Email invalid",
					"email_invalid_example": "Please change the address entered (name@example.com)",
					"instagram_tooltip": "Share on Instagram",
					"facebook_tooltip": "Share on Facebook",
					"twitter_tooltip": "Share on Twitter",
					"linkedin_tooltip": "Share on Linkedin",
					"whatsapp_tooltip": "Share on Whatsapp",
					"clipboard_tooltip": "Copy link",
					"copied_link": "Link copied to clipboard"
				}
			},
			"asset_manager": "My asset manager",
			"course": "Course",
			"courses": "Courses",
			"content": {
				"at_most_one": "Content",
				"more_one": "Contents"
			},
			"edit": {
				"NEW_PROFILE": "Adjust my picture",
				"NEW_FILTER": "Add a Filter"
			},
			"message": "Contact"
		},
		"action": {
			"follow": "Follow",
			"unfollow": "Unfollow",
			"follow_back": "Follow back"
		},
		"suggest": {
			"title": "People to follow.",
			"empty": "No suggestion available at the moment"
		},
		"menu": {
			"organizations": "My school pages",
			"settings": "Settings",
			"courses": "My content",
			"favorite": "My favorites",
			"discussions": "My groups",
			"sharerooms": "My Classrooms",
			"backoffice": "Backoffice",
			"application": "My application",
			"experiences": "Professional experiences.",
			"edit": "Edit my profile",
			"categories": "My interests"
		},
		"organizations": {
			"title": "My school pages.",
			"new": "Add a school page",
			"empty": "You haven't created any pages"
		},
		"followers": {
			"title": "Followers",
			"empty": "This profile doesn't have any follower"
		},
		"followees": {
			"title": "Following.",
			"empty": "This profile has no followers yet."
		},
		"experiences": {
			"title": "Professional experiences.",
			"new": "Add an experience",
			"label": "Professional experiences.",
			"empty": "This user didn't add any experience"
		},
		"academic_experiences": {
			"title": "Academic experiences.",
			"new": "Add a school experience",
			"label": "School experiences.",
			"empty": "This user has not added any school experiences"
		},
		"professional_experiences": {
			"title": "School experiences.",
			"new": "Add a professional experience",
			"label": "Professional experiences.",
			"empty": "This user has not added professional experiences"
		},
		"edit": {
			"title": "Edit my profile.",
			"avatar": "Profile picture",
			"crop": {
				"avatar": {
					"title": "Add / Edit my profile picture",
					"description": "Drag to reposition the photo"
				},
				"error_message": "You must have a standard profile picture  {{size}} x {{size}}",
				"filter": {
					"no_filter": "#none"
				},
				"add_filter_from_another_profile": {
					"title": "Apply to my profile picture",
					"message": "Filter well applied to your profile."
				}
			},
			"banner": "Banner",
			"name": "Full name",
			"firstName": "First name",
			"lastName": "Last name",
			"country": "Country",
			"description": "Profile title",
			"presentation": "Presentation"
		},
		"save": {
			"error": "An error has occured"
		},
		"categories": {
			"title": "My interests"
		},
		"complete": {
			"label": "Complete your profile",
			"phone": {
				"title": "Add your phone number",
				"lead": "Required to access partner offers.",
				"placeholder": "77 123 45 67",
				"invalid": "Enter a valid number (9 digits minimum).",
				"empty": "Enter your number or skip this step."
			},
			"language": {
				"title": "Platform language",
				"lead": "Choose the display language for Jaangal."
			},
			"country": {
				"title": "Your country",
				"lead": "Tell us your country of residence."
			},
			"birth": {
				"title": "Your date of birth",
				"lead": "It helps us tailor the content we show you."
			},
			"gender": {
				"title": "Who are you?",
				"lead": "So we can personalize your experience.",
				"other": "Other"
			},
			"interests": {
				"title": "Your interests",
				"lead": "Choose the topics that interest you."
			},
			"follows": {
				"title": "Profiles to follow",
				"lead": "Follow members to enrich your feed."
			},
			"skip": "Skip",
			"finish": "Finish",
			"thanks": {
				"title": "Thanks, you're all set!",
				"lead": "Your profile is up to date. Enjoy Jaangal fully: personalized content and partner offers are unlocked.",
				"action": "Go to my feed"
			}
		},
		"self": {
			"button": "My profile",
			"shareroom_premium": {
				"empty_all": "You are not in any paid classroom"
			},
			"shareroom_free": {
				"empty_all": "You're not in any classrooms"
			},
			"shareroom_free_member": {
				"empty": "You're not a learner in any classroom"
			},
			"shareroom_premium_member": {
				"empty": "You are not a learner in any paid classroom"
			},
			"shareroom_free_administrator": {
				"empty": "You're not a trainer in any classroom"
			},
			"shareroom_premium_administrator": {
				"empty": "You are not a trainer in any paid classroom"
			}
		},
		"experiences_self": {
			"empty": "You didn't add any experience"
		},
		"academic_experiences_self": {
			"empty": "You have not added any school experiences"
		},
		"professional_experiences_self": {
			"empty": "You have not added any professional experiences"
		},
		"auth": {
			"incentive": "Access to the full profile of {{name}} by signing in"
		},
		"selector": {
			"placeholder": "Choose a profile"
		},
		"carousel_self": {
			"empty_all": "You haven't published any carousel."
		},
		"carousels": {
			"empty": "{{user}} hasn't published any carousel."
		},
		"application": {
			"popin-success": {
				"label": "Congratulations !",
				"message": "You have successfully completed your application area. Watch your notifications for the status of your application.",
				"share-profile": {
					"label": "Share your profile and invite your friends to vote for you !"
				}
			}
		},
		"shareroom_premium": {
			"empty_all": "{{name}} is not in any paid classroom"
		},
		"shareroom_free": {
			"empty_all": "{{name}} is not in any classrooms"
		},
		"shareroom_free_member": {
			"empty": "{{name}} is not a learner in any classroom`"
		},
		"shareroom_premium_member": {
			"empty": "{{name}} is not a learner in any paid classroom"
		},
		"shareroom_free_administrator": {
			"empty": "{{name}} is a trainer in any classroom"
		},
		"shareroom_premium_administrator": {
			"empty": "{{name}} is not a trainer in any paid classroom"
		}
	},
	"{{user}} hasn't created any article": {
		"": "Courses"
	},
	"backoffice": {
		"page": {
			"title": "Backoffice"
		},
		"tab": {
			"REPORTS": "Reports",
			"APPLICATIONS": "Applications",
			"communication": "Communication"
		},
		"communication": {
			"title": "Communication",
			"description": "Edit there the illustration you want to use to communicate with the Jaangal users.",
			"url": {
				"label": "Image hyperlink (optional)",
				"placeholder": "https://example.com"
			},
			"submit": "Save"
		},
		"application": {
			"fullname": "Full name",
			"residence": "Country",
			"degree": "Degree",
			"program": "Program",
			"status": "Status",
			"filter": {
				"reset": "Reset",
				"candidat": "Candidat"
			}
		}
	},
	"experience": {
		"create": {
			"title": "New experience"
		},
		"academic": {
			"create": {
				"title": "New school experience"
			},
			"name": {
				"title": "Name of Institution*",
				"placeholder": "i.e.: Middle School Seydina Limamoulaye"
			},
			"diploma": {
				"title": "Degree level",
				"placeholder": "i.e.: bachelor, master…"
			},
			"domain": {
				"title": "Track",
				"placeholder": "i.e.: S1, S2, G..."
			},
			"title": {
				"title": "Track title*",
				"placeholder": "i.e.: Mathematics and Physical Sciences"
			},
			"current": {
				"check": "This is my current training"
			},
			"info": {
				"current": "Current training"
			}
		},
		"professional": {
			"create": {
				"title": "New professional experience"
			},
			"name": {
				"title": "Company name*",
				"placeholder": "Company name"
			},
			"title": {
				"title": "Job title*",
				"placeholder": "job title"
			},
			"current": {
				"check": "This is my current job."
			},
			"info": {
				"current": "Current job"
			}
		},
		"edit": {
			"title": "Edit an experience"
		},
		"name": {
			"title": "Institute name"
		},
		"country": {
			"title": "Country",
			"placeholder": "Location"
		},
		"title": {
			"placeholder": "Job title"
		},
		"start": {
			"label": "Start date"
		},
		"end": {
			"label": "End date"
		},
		"current": {
			"check": "This is my current job"
		},
		"teacher": {
			"check": "Professor position (trainer, coach...)"
		},
		"save": {
			"success": "Your changes have been saved."
		},
		"info": {
			"teacher": "Trainer"
		},
		"delete": {
			"title": "Are you sure you want to delete this experience?"
		}
	},
	"feed": {
		"empty": "{{user}} hasn't created any content",
		"self": {
			"empty": "Find here your publications and sharing with your community. Go ahead and create your first post!"
		},
		"incentive": {
			"info": "Find here your publications and sharing with your community.",
			"button": "Add my first post"
		},
		"suggestions": {
			"title": "Discover",
			"users": "Profiles to discover",
			"courses": "Suggested courses",
			"organizations": "Organizations to follow",
			"quizzes": "Suggested quizzes",
			"groups": "Suggested discussion groups",
			"sharerooms": "Suggested classrooms"
		}
	},
	"tag": {
		"ALL": "All",
		"ARTICLE": "Insights",
		"COURSE": "Courses",
		"CAROUSEL": "Carousels",
		"FREE": "Free",
		"PREMIUM": "Premium"
	},
	"course": {
		"action": {
			"edit": "Edit",
			"share_detail": "Share on my profile"
		},
		"header": "Courses.",
		"infos": {
			"date": "Last edited {{date}}",
			"date_published": "Published {{date}}",
			"category": "In :",
			"subcategory": "Sub-category :"
		},
		"editor": {
			"header": "Edit a course",
			"new": {
				"header": "Create a course"
			},
			"image": {
				"upload": "Add a picture"
			},
			"title": {
				"placeholder": "Give a title for your course...",
				"missing": "Untitled course"
			},
			"description": {
				"placeholder": "Add a description...",
				"label": "Description"
			},
			"save": {
				"draft": "Save your draft",
				"published": "Save",
				"default": "Save",
				"preview": "Save and preview"
			},
			"preview": "Preview",
			"required_data": "Fields with an ansterisk (*) must be filled for the course to be published. If saving as draft, only title is mandatory.",
			"publish": "Publish your course",
			"archive": "Archive your course",
			"delete": "Delete this course",
			"section": {
				"add": "Add an element",
				"video": {
					"new": "Video",
					"placeholder": "Add YouTube link here"
				},
				"youtube": {
					"new": "YouTube link",
					"placeholder": "Add Youtube link here"
				},
				"text": {
					"new": "Text",
					"placeholder": "Write your text here..."
				},
				"image": {
					"new": "Image"
				},
				"document": {
					"new": "PDF"
				},
				"qcm": {
					"new": "Multiple choices question"
				},
				"subtitle": {
					"new": "Subtitle",
					"placeholder": "Add a subtitle"
				},
				"attachment": {
					"new": "Attachement",
					"placeholder": "Attachement's title"
				}
			},
			"qcm": {
				"add": "New question",
				"title": {
					"placeholder": "Edit the question...*"
				},
				"answer": {
					"add": "Add an answer",
					"placeholder": "Answer {{index}}*"
				},
				"choose_answer": "Choose the right answer",
				"comment": {
					"title": "Explanations",
					"placeholder": "Expand on the answer here.\nThis text will only be visible to the user after answering the question."
				},
				"title_missing": "Question title is mandatory.",
				"answer_empty": "Answers are missing content."
			},
			"banner": {
				"edit": "Edit the cover picture"
			},
			"introduction": {
				"add": "Add an introduction video",
				"edit": "Edit the introduction video"
			},
			"chapter": {
				"placeholder": "Add a title to your chapter",
				"add": "Add a new chapter"
			},
			"language": {
				"placeholder": "Language"
			},
			"level": {
				"placeholder": "Required level of the course*"
			},
			"publisher": {
				"label": "Publish as",
				"keep_ownership": "Be credited as the course author"
			},
			"details": {
				"publication": "Publication",
				"settings": "Settings",
				"presentation": "Course presentation",
				"shareroom": "Add to my Classrooms"
			},
			"step": {
				"back": "Back to editing"
			},
			"publish_modal": {
				"title": "Publish your course",
				"confirm": "Are you sure you've finished editing? Ready to publish? ",
				"share": "Generate an automatic post to notify your subscribers",
				"submit": "Publish my course",
				"share_placeholder": "Add a message...",
				"authorship": "I certify that I am the author of this course or that I hold the publication rights"
			}
		},
		"delete": {
			"title": "Do you really want to delete this content ?",
			"message": "It will not be visible by the community anymore. The attached publication will not be deleted."
		},
		"author": {
			"label": "Author.",
			"link": "See the profile"
		},
		"institute": {
			"link": "See school"
		},
		"company": {
			"link": "See company"
		},
		"toolbar": {
			"feedback": "My feedback",
			"feedback_edit": "Edit my feedback",
			"start": "Start",
			"external": {
				"UDEMY": "See on Udemy",
				"COURSERA": "See on Coursera"
			},
			"share": "Share"
		},
		"feedback": {
			"infos": "Give your feedback on the course",
			"stars": {
				"1": "Disappointing",
				"2": "So so",
				"3": "Good",
				"4": "Great",
				"5": "Excellent !"
			},
			"placeholder": "Your comment (optional)",
			"date": "Published {{date}}"
		},
		"feedbacks": {
			"empty": "No feedback yet",
			"title": "Feedback"
		},
		"section": {
			"qcm": {
				"title": "Multiple choice question",
				"number": "Question {{index}}"
			},
			"attachment": {
				"title": "File .{{type}}",
				"download": "Download"
			}
		},
		"status": {
			"PUBLISHED": "Published",
			"DRAFT": "Draft",
			"ARCHIVED": "Archived",
			"ALL": "Status"
		},
		"toast": {
			"save": {
				"title": "Saved",
				"message": "The course has been saved",
				"error": "An error occured"
			},
			"publish": {
				"message": "Your course has been published"
			},
			"archive": {
				"message": "Your course has been archived"
			},
			"delete": {
				"title": "Deletion",
				"message": "Your course has been deleted"
			}
		},
		"suggest": {
			"title": "Suggestions of courses.",
			"no_results": "No suggestion for the moment"
		},
		"content": {
			"back": "Back ",
			"quick_access": "Summary"
		},
		"chapter": {
			"prefix": "Chapter {{index}}: "
		},
		"thumbnail": {
			"from": "By",
			"you": "you",
			"badge_label": "Course"
		},
		"chapters": {
			"summary": "Course content"
		},
		"workspaces": {
			"add": "Add to a Classroom",
			"success": "The course has been added to the selected workspaces.",
			"error": "An error occured while adding the course.",
			"count": {
				"zero": "{{count}} workspace.",
				"one": "{{count}} workspace.",
				"other": "{{count}} workspaces."
			}
		},
		"auth": {
			"incentive": "Access this course by logging into Jaangal. "
		},
		"bookmark_title": "Bookmark"
	},
	"article": {
		"action": {
			"edit": "Edit",
			"share_detail": "Share on my profile"
		},
		"header": "Insights.",
		"infos": {
			"date": "Last edited {{date}}",
			"date_published": "Published {{date}}",
			"category": "In :",
			"subcategory": "Sub-category :"
		},
		"editor": {
			"header": "Edit an insight.",
			"new": {
				"header": "Create an insight."
			},
			"image": {
				"upload": "Add a picture"
			},
			"title": {
				"placeholder": "Give a title for your insight...",
				"missing": "Untitled insight"
			},
			"description": {
				"placeholder": "Add a description for the insight...",
				"label": "Description."
			},
			"save": {
				"draft": "Save your draft",
				"published": "Save",
				"default": "Save",
				"preview": "Save and preview"
			},
			"preview": "Preview",
			"required_data": "Fields with an ansterisk (*) must be filled for the insight to be published. If saving as draft, only title is mandatory.",
			"publish": "Publish your insight",
			"archive": "Archive your insight",
			"delete": "Delete this insight",
			"section": {
				"add": "Add an element",
				"video": {
					"new": "Video",
					"placeholder": "Add YouTube link here"
				},
				"youtube": {
					"new": "YouTube link",
					"placeholder": "Add Youtube link here"
				},
				"text": {
					"new": "Text",
					"placeholder": "Write your text here..."
				},
				"image": {
					"new": "Image"
				},
				"document": {
					"new": "PDF"
				},
				"qcm": {
					"new": "Multiple choices question"
				},
				"subtitle": {
					"new": "Subtitle",
					"placeholder": "Add a subtitle"
				},
				"attachment": {
					"new": "Attachement",
					"placeholder": "Attachement's title"
				}
			},
			"qcm": {
				"add": "New question",
				"title": {
					"placeholder": "Edit the question...*"
				},
				"answer": {
					"add": "Add an answer",
					"placeholder": "Answer {{index}}*"
				},
				"choose_answer": "Choose the right answer",
				"comment": {
					"title": "Explanations",
					"placeholder": "Expand on the answer here.\nThis text will only be visible to the user after answering the question."
				},
				"title_missing": "Question title is mandatory",
				"answer_empty": "Answers are missing content"
			},
			"banner": {
				"edit": "Edit the cover picture"
			},
			"language": {
				"placeholder": "Language"
			},
			"publisher": {
				"label": "Publish as",
				"keep_ownership": "Be credited as the insight author"
			},
			"details": {
				"news": {
					"label": "Latest news"
				},
				"publication": "Publication",
				"settings": "Settings",
				"presentation": "Insight cover",
				"shareroom": "Add to my Classrooms"
			},
			"step": {
				"back": "Back to editing"
			},
			"publish_modal": {
				"title": "Publish your insight",
				"confirm": "Are you sure you've finished editing? Ready to publish? ",
				"share": "Generate a post on your feed",
				"submit": "Publish my insight",
				"share_placeholder": "Add a message for this post...",
				"authorship": "I certify that I am the author of the content of this insight or that I hold the publication rights"
			}
		},
		"delete": {
			"title": "Do you really want to delete this content ?",
			"message": "It will not be visible by the community anymore. The attached publication will not be deleted."
		},
		"author": {
			"label": "Author.",
			"link": "See the profile"
		},
		"institute": {
			"link": "See school"
		},
		"company": {
			"link": "See company"
		},
		"toolbar": {
			"feedback": "My feedback",
			"feedback_edit": "Edit my feedback",
			"start": "Start",
			"share": "Share"
		},
		"feedback": {
			"infos": "Give your feedback on the insight",
			"stars": {
				"1": "Disappointing",
				"2": "Passable",
				"3": "Good",
				"4": "Great",
				"5": "Excellent !"
			},
			"placeholder": "Your comment",
			"created_date": "Published on {{date}}",
			"updated_date": "Edited on {{date}}",
			"created_hour": "at {{hour}}"
		},
		"feedbacks": {
			"empty": "No comments yet",
			"title": "Feedback"
		},
		"section": {
			"qcm": {
				"title": "Multiple choice question",
				"number": "Question {{index}}"
			},
			"attachment": {
				"title": "File .{{type}}",
				"download": "Download"
			}
		},
		"status": {
			"PUBLISHED": "Published",
			"DRAFT": "Draft",
			"ARCHIVED": "Archived",
			"ALL": "Status"
		},
		"toast": {
			"save": {
				"title": "Saved",
				"message": "The insight has been saved.",
				"error": "An error occured."
			},
			"publish": {
				"message": "Your insight has been published."
			},
			"archive": {
				"message": "Your insight has been archived."
			},
			"delete": {
				"title": "Deletion",
				"message": "Your insight has been deleted."
			}
		},
		"suggest": {
			"title": "Last insights.",
			"no_results": "No suggestion for the moment"
		},
		"content": {
			"back": "Back ",
			"quick_access": "Summary"
		},
		"chapter": {
			"prefix": "Chapter {{index}}: "
		},
		"thumbnail": {
			"from": "By",
			"you": "you",
			"badge_label": "Insight"
		},
		"chapters": {
			"summary": "Insight content."
		},
		"workspaces": {
			"add": "Add to a Classroom",
			"success": "This insight has been added to the selected workspaces",
			"error": "An error occured while adding the insight.",
			"count": {
				"zero": "{{count}} workspace.",
				"one": "{{count}} workspace.",
				"other": "{{count}} workspaces."
			}
		},
		"auth": {
			"incentive": "Access to more insights by signing in, it's free !"
		},
		"comments": "Comments",
		"add_comment": "Add a comment",
		"suggestions": "Trending insights",
		"news": "Trending news",
		"delete_feedback": {
			"title": "Are you sure you want to delete your comment ?"
		}
	},
	"settings": {
		"menu": {
			"title": "Settings.",
			"notifications": "Notification settings",
			"system": "General settings",
			"confidentiality": "Confidentiality",
			"more": "More",
			"login": "Connection parameters"
		},
		"notifications": {
			"title": "Notification settings.",
			"header": {
				"type": "Type of notification",
				"email": "Email",
				"app_notification": "Notifications"
			}
		},
		"system": {
			"title": "Set your general settings.",
			"content": {
				"language": {
					"title": "Language"
				},
				"currency": {
					"title": "Default currency"
				},
				"email": {
					"title": "Email"
				}
			}
		},
		"more": {
			"title": "More."
		},
		"login": {
			"title": "Update your connection settings",
			"phonenumber": {
				"label": "Phone number",
				"add": "Add my phone number",
				"update": "Change my phone number"
			}
		},
		"save": {
			"success": "Settings saved ! "
		},
		"change": {
			"email": {
				"label": "Change your email address",
				"infos": "Enter your email, then we'll send you an update link.",
				"placeholder": "Enter your current email",
				"link": {
					"title": "Change my authentication email "
				},
				"message": "We are sending you a link to change your email.",
				"new": {
					"placeholder": "Enter your new email",
					"confirm": {
						"placeholder": "Re-enter your new email"
					}
				},
				"success": "You can now use your new email address !"
			}
		},
		"delete": {
			"account": {
				"label": "Are you sure you want to delete your Jaangal account?",
				"success": "Request well taken into account",
				"link": {
					"title": "Account deletion request"
				}
			}
		},
		"currency": {
			"USD": "Dollars US",
			"EUR": "Euro",
			"CHF": "Swiss franc",
			"XOF": "XOF",
			"placeholder": "Choose a default currency"
		},
		"link_phonenumber": {
			"title": "Add your authentication number",
			"label": "Enter your phone number",
			"otp": {
				"title": "Checking the phone number entered",
				"label": "OTP validation code",
				"message": "Please enter the code received on the",
				"toast": {
					"success": {
						"message": "Your phone number has been registered!"
					},
					"error": {
						"message": "You have entered the wrong OTP code. Please try again!"
					}
				}
			},
			"toast": {
				"success": {
					"message": "An OTP code will be sent to you by SMS"
				},
				"error": {
					"message": "An error has occurred. Please try again!"
				}
			}
		},
		"modify_phonenumber": {
			"title": "Modify your authentication phone number",
			"otp": {
				"toast": {
					"success": {
						"message": "Your phone number has been changed !"
					}
				}
			}
		},
		"modal": {
			"update_phonenumber": {
				"title": "Enter your current phone number"
			}
		},
		"update_phonenumber": {
			"toast": {
				"error": {
					"message": "The phone number entered does not match your current phone number."
				}
			},
			"title": "Change my authentication phone number",
			"label": "Please enter your new phone number"
		}
	},
	"setting": {
		"notifications": {
			"content": {
				"followups": {
					"title": "Following and followers",
					"description": "A user has started following me."
				},
				"mentions": {
					"title": "Mentions",
					"description": "A user has identified me in a post or comment."
				},
				"sharing": {
					"title": "Shared content",
					"description": "A user has shared content that I have created or in which I am identified."
				},
				"likes": {
					"title": "Likes",
					"description": "A user liked content that I created or in which I am identified."
				},
				"comments": {
					"title": "Comments",
					"description": "A user has commented on content that I created or in which I am identified."
				},
				"publications": {
					"title": "Publications",
					"description": "A user that I follow has posted educational content."
				},
				"feedbacks": {
					"title": "Feedbacks",
					"description": "A user provided feedback on educational content that I posted."
				},
				"participations": {
					"title": "Participations",
					"description": "A user has participated in one of my quizzes."
				},
				"associations": {
					"title": "Associations",
					"description": "A user associated me with a school page."
				},
				"organizations": {
					"title": "Associations",
					"description": "A user associated me with a school page."
				},
				"deletions": {
					"title": "Content deleted.",
					"description": "A user deleted educational content linked to a school page that I am associated with."
				},
				"sharerooms": {
					"title": "Classrooms",
					"description": "A user invited me to join a Classroom"
				},
				"groups": {
					"title": "Discussion groups",
					"description": "A user invited me to join a discussion group"
				},
				"system": {
					"title": "System",
					"description": "A content has been removed by an administrator"
				},
				"instructive": {
					"title": "Instructive Content",
					"description": "A user tagged content I have created as informative"
				},
				"live_course": {
					"title": "Live courses",
					"description": "A classrom or a page which i am subscribed launches a live course"
				}
			}
		}
	},
	"organization": {
		"create": {
			"title": "Add a school page",
			"button": "New",
			"switch": {
				"title": "What type of page do you want to create ?"
			},
			"institute": {
				"title": "Educational / Training institute",
				"description": "Create a page for your school. Share information about your teaching and highlight educational content."
			},
			"company": {
				"title": "Company",
				"description": "Present your company on Jaangal, make yourself known to the young talents present on the platform and broadcast your job and internship offers."
			}
		},
		"edit": {
			"title": "Edit a school page"
		},
		"logo": {
			"add": "Add a logo",
			"edit": "Edit logo"
		},
		"banner": {
			"add": "Add a banner",
			"edit": "Edit banner"
		},
		"save": {
			"button": "Save",
			"error": "An error occurred during the backup.",
			"success": "The changes have been saved."
		},
		"form": {
			"creationDate": {
				"title": "Year of creation"
			},
			"country": {
				"title": "Country*",
				"placeholder": "Choose the country"
			},
			"instituteType": {
				"title": "Type of school*",
				"placeholder": "Choose the type of school"
			},
			"companyType": {
				"title": "Type of company",
				"placeholder": "Choose the type of company"
			},
			"primaryName": {
				"title": "Name*",
				"placeholder": "Add name"
			},
			"description": {
				"title": "Short description*",
				"placeholder": "Add a short description"
			},
			"email": {
				"title": "Contact email*",
				"placeholder": "Add email"
			},
			"address": {
				"title": "Address",
				"placeholder": "Add mailing address"
			},
			"phoneNumber": {
				"title": "Phone",
				"placeholder": "Add phone"
			},
			"webSite": {
				"title": "Website",
				"placeholder": "Add website url"
			}
		},
		"report": {
			"mail": "report@jaangal.com",
			"button": "Report this page"
		},
		"delete": {
			"title": "Do you really want to delete this organization ?",
			"infos": "Users will not be able to see this organization on Jaangal.  This action is irreversible."
		},
		"toast": {
			"delete": {
				"message": "The orgnization has been removed"
			}
		},
		"switch": {
			"message": "Page seen as",
			"admin": "Administrator",
			"user": "Visitor"
		},
		"tab": {
			"activity": "Activity",
			"presentation": "Presentation",
			"courses": "Courses",
			"content": "Content",
			"community": "Community",
			"tracks": "Tracks",
			"shareroom": "Groups and Classrooms",
			"events": "Events"
		},
		"tracks": {
			"empty": "This school didn't add tracks yet",
			"new": "Add a track",
			"edit": "Edit a track",
			"presentation": {
				"owner": {
					"description": "Showcase the programs and courses offered by your school."
				},
				"member": {
					"description": "No programs have been added to this page yet."
				}
			}
		},
		"track": {
			"create": {
				"success": "The track has been created"
			},
			"save": {
				"success": "The track has been saved"
			},
			"level": {
				"placeholder": "Level*"
			},
			"name": {
				"placeholder": "Name*"
			},
			"description": {
				"placeholder": "Description"
			},
			"levels": {
				"label": "Available dipolomas",
				"placeholder": "ex : Baccalauréat S1, T2, etc…"
			},
			"presentation": "Presentation",
			"logo": {
				"add": "Add a logo",
				"edit": "Edit the logo"
			}
		},
		"details": {
			"mobile_title": "Information",
			"year_of_creation": {
				"label": "Created in {{year}}"
			},
			"categories": {
				"institute": {
					"add": "Add fields of training"
				},
				"company": {
					"add": "Add fields of activity"
				},
				"edit": "Edit"
			}
		},
		"categories": {
			"institute": {
				"title": "Fields of training"
			},
			"company": {
				"title": "Fields of activity"
			}
		},
		"type": {
			"UNIVERSITY": "University",
			"HIGH_SCHOOL": "High School",
			"MIDDLE_SCHOOL": "Middle School",
			"PROFESSIONAL_TRAINING_CENTER": "Professional Training Center",
			"CERTIFICATION_CENTER": "Certification Center",
			"HIGHER_EDUCATION_INSTITUTE": "Higher Institute",
			"ACADEMY": "Academy",
			"RESEARCH_CENTER": "Research Center",
			"GENERAL_EDUCATION_INSTITUTE": "General Institute",
			"POLYTECHNIC_INSTITUTE": "Polytechnic Institute",
			"NATIONAL_HIGHER_SCHOOL": "National Higher School",
			"ARTIST": "Artist",
			"ASSOCIATION": "Association",
			"NON_PROFIT_ORGANIZATION": "NGO",
			"CHARITABLE_ORGANIZATION": "Charity association",
			"COMMUNITY_ORGANIZATION": "Community organization",
			"INDIVIDUAL_COMPANY": "Individual company",
			"PUBLIC_COMPANY": "Public organization",
			"PRIVATE_COMPANY": "Private organization",
			"PUBLIC_FIGURE": "Public Figure "
		},
		"header": {
			"quick_edit": "Edit my page",
			"follow": "Subscribe",
			"unfollow": "Unsubscribe"
		},
		"presentation": {
			"title": "Presentation",
			"empty": "This organization didn't add a presentation yet",
			"button": "Add a presentation",
			"placeholder": "Add a presentation to your organization"
		},
		"pictures": {
			"title": "Photos",
			"add": "Add photos",
			"presentation": {
				"owner": {
					"description": "Add photos of your institution to help students better envision themselves there."
				},
				"member": {
					"description": "No photos have been added to this page yet."
				}
			}
		},
		"accreditations": {
			"title": "Accreditations",
			"empty": "No accreditation has been added",
			"new": "Add an accreditation",
			"edit": "Edit an accreditation",
			"presentation": {
				"owner": {
					"description": "Provide the accreditations and recognitions held by your institution."
				},
				"member": {
					"description": "No accreditations have been added to this page yet."
				}
			}
		},
		"accreditation": {
			"logo": {
				"edit": "Logo edition",
				"add": "Add a picture"
			},
			"name": {
				"placeholder": "Name*"
			},
			"reference": {
				"placeholder": "Reference number*",
				"view": "Reference number {{reference}}"
			},
			"description": {
				"placeholder": "Add a description"
			},
			"date": {
				"label": "Year of the award",
				"view": "Since {{year}}"
			},
			"save": {
				"success": "The accreditation has been saved"
			},
			"delete": {
				"success": "The accreditation has been removed"
			}
		},
		"teachers": {
			"list": {
				"title": "Our teachers. ({{count}})",
				"empty": "This organization didn't add any teachers yet"
			},
			"add": {
				"title": "Add teachers.",
				"button": "Add teachers",
				"success": "The trachers have successfully been added."
			},
			"more": "See more",
			"delete": {
				"success": "The user has been removed from the teacher list.",
				"title": "Do you really want to remove this teacher ?"
			}
		},
		"detailed_teachers": {
			"list": {
				"title": "Teachers ({{count}})"
			}
		},
		"join": {
			"title": "Join {{name}}!",
			"button": "Contact us!"
		},
		"course": {
			"incentive": "Create a course for {{institute}}"
		},
		"quizze": {
			"incentive": "Create a quizz for {{institute}}"
		},
		"article": {
			"incentive": "Create a insight for {{institute}}"
		},
		"diploma": {
			"edit": "Edit a diploma",
			"new": "Create a diploma",
			"title": {
				"placeholder": "Training name"
			},
			"description": {
				"placeholder": "Training description"
			},
			"duration": {
				"placeholder": "Training duration",
				"label": "Duration"
			},
			"type": {
				"INITIAL": "Initial training",
				"CONTINUOUS": "Continuous training",
				"ALTERNATING": "Alternating training",
				"label": "Type"
			},
			"mode": {
				"FACE_TO_FACE": "Face-to-face",
				"DISTANCE": "Remote",
				"MIXED": "Mixed",
				"label": "Mode"
			},
			"delete": {
				"success": "The training has been deleted."
			},
			"save": {
				"success": "The training has been saved."
			},
			"create": {
				"success": "The training has been created."
			}
		},
		"members": {
			"search": {
				"placeholder": "Search for a member..."
			},
			"role": {
				"CONTRIBUTOR": "Teacher",
				"ADMINISTRATOR": "Admin"
			},
			"CONTRIBUTOR": {
				"list": {
					"title": "Teachers ({{count}})"
				}
			},
			"ADMINISTRATOR": {
				"list": {
					"title": "Admins ({{count}})"
				}
			},
			"add": {
				"error": "An error occured while adding members."
			},
			"delete": {
				"error": "An error occured while removing member"
			}
		},
		"CONTRIBUTOR": {
			"add": {
				"title": "Add teachers.",
				"button": "Add teachers.",
				"success": "The teachers have successfully been added."
			},
			"delete": {
				"success": "The user has been removed from the teacher list.",
				"title": "Do you really want to remove this teacher ?",
				"self": {
					"title": "Do you really want to remove yourself as a teacher ?"
				}
			}
		},
		"ADMINISTRATOR": {
			"add": {
				"title": "Add admins.",
				"button": "Add admins",
				"success": "The admins have successfully been added."
			},
			"delete": {
				"success": "The user has been removed from the admin list.",
				"title": "Do you really want to remove this admin ?",
				"self": {
					"title": "Do you really want to remove yourself as an admin ?"
				}
			}
		},
		"auth": {
			"incentive": "Access all of {{name}}'s information by logging into Jaangal. "
		},
		"transfer_ownership": {
			"button": "Transfer ownership of the page",
			"title": "Transfer ownership of the page.",
			"selection": "Please choose which administrator will take over ownership of the page.",
			"confirmation": "Are you sure you want to transfer your role of Super Admin to this user?"
		},
		"distinction": {
			"title": "Awards",
			"empty": "No award has been added",
			"new": "Add an award",
			"edit": "Edit an award",
			"logo": {
				"edit": "Logo edition",
				"add": "Add a picture"
			},
			"name": {
				"placeholder": "Name*"
			},
			"reference": {
				"placeholder": "Reference number*",
				"view": "Reference number {{reference}}"
			},
			"description": {
				"placeholder": "Add a description"
			},
			"date": {
				"label": "Year of the award",
				"view": "Since {{year}}"
			},
			"save": {
				"success": "The award has been saved"
			},
			"delete": {
				"success": "The award has been removed"
			}
		},
		"about": {
			"presentation": {
				"owner": {
					"description": "Introduce your school, its educational philosophy, core values, and facilities."
				},
				"member": {
					"description": "No presentation has been added to this page yet."
				}
			}
		}
	},
	"track": {
		"level": {
			"bachelor": "Bachelor",
			"master": "Master",
			"phd": "PHD",
			"mba": "MBA",
			"baccalaureat": "Baccalauréat",
			"bepc": "BEPC"
		}
	},
	"onboarding": {
		"hello": "Hi",
		"verify": {
			"infos": "To verify your email address, we will send a verification link to {{email}}",
			"retry": "Send again",
			"sent": "A new confirmation email has been sent"
		},
		"infos": {
			"presentation": "Please tell us more about yourself to enjoy a better experience on Jaangal."
		},
		"next": "Next",
		"gender": {
			"male": "Man",
			"female": "Woman",
			"other": "Other"
		},
		"birth": {
			"placeholder": "Year of birth"
		},
		"language": {
			"FRENCH": "French",
			"ENGLISH": "English",
			"placeholder": "Favorite language"
		},
		"country": {
			"placeholder": "Country of residence "
		},
		"categories": {
			"title": "Select the topics you like",
			"minimum": "({{min}} minimum)"
		},
		"follows": {
			"title": "Follow inspiring profiles",
			"minimum": "({{min}} minimum)"
		},
		"end": "Start"
	},
	"verify": {
		"title": "Email verification",
		"error": {
			"expired": "This code has expired",
			"invalid": "This code is invalid",
			"disabled": "This account has been disabled",
			"not_found": "This account doesn't exist"
		},
		"success": "The email has been verified, you can now login"
	},
	"modal": {
		"publish": {
			"title": "Publish your course",
			"confirm": "Are you ready to publish ?",
			"share": "Generate a post to inform your followers",
			"submit": "Publish my course",
			"share_placeholder": "Add a message..."
		}
	},
	"more": {
		"page": {
			"faq": "FAQ",
			"feedback": "Feedback",
			"cgu": "Terms of Service",
			"policy": "Privacy Policy ",
			"notice": "Legal Notice ",
			"about": "About",
			"support": "Support"
		},
		"copyright": "© {{currentYear}} Jaangal",
		"about": "Learn more about Jaangal"
	},
	"upload": {
		"error": {
			"format": "This file format is not accepted.",
			"size": "The file is size is too large (max size: 250MB).",
			"size_small": {
				"title": "File too large.",
				"message": "To upload files larger than 100MB, please use your asset manager"
			},
			"pending": "An upload in already pending",
			"unknown": "An error occured while uploading"
		},
		"canceled": "The upload has been canceled"
	},
	"notification": {
		"title": "Notifications",
		"follower": "started following you",
		"read_all": "Mark all as read.",
		"post": {
			"new": {
				"male": "mentioned you in a post",
				"female": "mentioned you in a post.",
				"other": "mentioned you in a post",
				"organization": "mentioned your organization {{name}}"
			},
			"self": {
				"like": "liked your post",
				"share": "shared your post.",
				"comment": "commented your post"
			},
			"mention": {
				"like": {
					"male": "liked a post you're mentioned in",
					"female": "liked a post you're mentioned in",
					"other": "liked a post you're mentioned in",
					"organization": "liked a post your orgnization {{name}} is mentioned in"
				},
				"share": {
					"male": "shared a post you're mentioned in",
					"female": "shared a post you're mentioned in",
					"other": "shared a post you're mentioned in",
					"organization": "shared a post your orgnization {{name}} is mentioned in"
				},
				"comment": {
					"male": "commented a post you're mentioned in",
					"female": "commented a post you're mentioned in",
					"other": "commented a post you're mentioned in",
					"organization": "commented a post your orgnization {{name}} is mentioned in"
				}
			}
		},
		"comment": {
			"male": "mentioned you in a comment",
			"female": "mentioned you in a comment",
			"other": "mentioned you in a comment",
			"organization": "mentioned your organization {{name}} in a comment"
		},
		"course": {
			"new": "published a new course",
			"feedback": {
				"new": "left a feedback for your course"
			},
			"deleted": "deleted the course {{course}}"
		},
		"empty": "You have no new notifications.",
		"institute": {
			"linked": {
				"male": "You have been added as a teacher at {{institute}}",
				"female": "You have been added as a teacher at {{institute}}",
				"other": "You have been added as a teacher at {{institute}}",
				"CONTRIBUTOR": {
					"male": "You have been added as a teacher at {{institute}}",
					"female": "You have been added as a teacher at {{institute}}",
					"other": "You have been added as a teacher at {{institute}}"
				},
				"ADMINISTRATOR": {
					"male": "You have been added as an admin at {{institute}}",
					"female": "You have been added as an admin at {{institute}}",
					"other": "You have been added as an admin at {{institute}}"
				},
				"SUPER_ADMINISTRATOR": {
					"male": "You have been added as super admin of {{institute}}",
					"female": "You have been added as super admin of {{institute}}",
					"other": "You have been added as super admin of {{institute}}."
				}
			}
		},
		"quiz": {
			"new": "published a new quiz",
			"participation": "participated in your quiz",
			"deleted": "deleted the quiz "
		},
		"group": {
			"invited": {
				"male": "invited you to join",
				"female": "invited you to join",
				"other": "invited you to join"
			},
			"accepted": "accepted to join"
		},
		"discussion": {
			"removed": {
				"male": "removed you from the group",
				"female": "removed you from the group",
				"other": "removed you from the group"
			},
			"request": "asked to join the group",
			"granted": "approved your request to join the group"
		},
		"shareroom": {
			"removed": {
				"male": "removed you from the classroom",
				"female": "removed you from the classroom",
				"other": "removed you from the classroom"
			},
			"subscription": "has just subscribed to your classroom",
			"request": "asked to join the classroom",
			"granted": "approved your request to join the classroom"
		},
		"moderated": "Your {{content}} has been moderated by an administrator for the following reason:",
		"organization": {
			"deleted": "deleted the organization",
			"mention": "identified your organization {{name}}"
		},
		"article": {
			"new": "published a new insight",
			"feedback": {
				"new": "commented your insight"
			},
			"deleted": "deleted the insight {{insight}}."
		},
		"carousel": {
			"new": "published a new carousel",
			"instructive": "found your carousel insightful"
		},
		"live": {
			"live": "just started a live course",
			"planned": "scheduled a live course"
		},
		"share_application": {
			"new": "published his OMAT application video"
		}
	},
	"tooltip": {
		"home": "Home",
		"editor": "Create a course",
		"feed": "Home"
	},
	"toast": {
		"success": "Success"
	},
	"app": {
		"register": {
			"connectwith": "Or connect easily with:",
			"firstName": "Your first name ",
			"lastName": "Your last name ",
			"password": "Password"
		},
		"firebase": {
			"invalid-custom-token": "Invalid token",
			"invalid-credential": "Invalid identifiers",
			"user-disabled": "User deactivated",
			"email-already-in-use": "Email address already in use",
			"invalid-email": "Invalid email",
			"wrong-password": "Invalid password",
			"user-not-found": "User not found",
			"account-exists-with-different-credential": "This user exists with different identifiers",
			"invalid-user-token": "User token expired",
			"network-request-failed": "Connexion error",
			"user-mismatch": "Users do not match",
			"credential-already-in-use": "Identifiers already used",
			"weak-password": "Weak password",
			"invalid-recipient-email": "Invalid receipt email address",
			"missing-app-credential": "Please enter your login details",
			"invalid-app-credential": "The username entered is invalid",
			"code-expired": "Code has expired",
			"quota-exceeded": "You have reached your quota",
			"app-not-verified": "Application not verified",
			"popup-closed-by-user": "Connection attempt canceled",
			"internal-error": "Internal error",
			"passwordsDoNotMatch": "Passwords do not match",
			"googleAuthPlayServices": "Google Play Services are unavailable",
			"googleAuthInProgress": "Google connection in progress",
			"too-many-requests": "Please wait a moment before trying to login again"
		}
	},
	"banner": {
		"description": "Jaangal is now available on Google Play Store.",
		"link": "Download",
		"text": "the mobile app now !"
	},
	"program": {
		"page": {
			"sub_title": "AFRICAN TALENTS CHALLENGE",
			"full_title": "One Million African Talents ",
			"title": "ONE MILLION",
			"baseline": {
				"title": "Reveal your talent and get a scholarship"
			},
			"challenge": {
				"title": "Showcase your talent with a 30 second video story"
			},
			"description": {
				"p1": "Jaangal allows you to apply for a scholarship from the International University of Applied Sciences for Bachelor, Master and MBA programs delivered 100% online. ",
				"p2": "To get involved, showcase your talent in a video of less than one minute. To validate your participation you will have to complete the application steps of the One Million African Talents program. "
			},
			"about": {
				"title": "About the program",
				"description": {
					"p1": "The One Million African Talents program is the realization of an ambitious project that offers young Africans the opportunity to have access to a quality education that meets the standards of the best universities and training centers in the world.",
					"p2": "In partnership with the Study Access Alliance, Jaangal will provide scholarships for online university degrees at IU International University of Applied Sciences to those who would otherwise not be financially able to study.\n\nWith over 75,000 students, IU International University is the largest university in Germany and the fastest growing university in Europe. The state-accredited university offers the broadest degree portfolio globally with a focus on tech and management. Scholarships will be available for Bachelor’s, Master’s and MBA online degrees, which take 1-3 years to complete.",
					"p3": "The launch of the first part of the One Million African Talents programme will be marked by the awarding of scholarships to 100,000 African students who will benefit from online certification courses over a period of 5 years."
				}
			},
			"partner": {
				"title": "Making online studies even more accessible"
			},
			"partner-saa": {
				"description": {
					"p1": "We want to bridge the higher education gap in Africa with high quality, highly scalable online education with maximum employability and value for money to empower people and support sustainable development.",
					"p2": "We believe that Study Access Alliance Africa will enable students to grow and we are convinced that the initiative has the potential to shape higher education and support sustainable economic development in Africa."
				}
			},
			"partner-iu": {
				"description": {
					"p1": "IU International University of Applied Science, with more than 10 years of experience as Germany's largest distance learning university, helps you find the distance learning degree that matches your career ambitions.",
					"p2": "Our programs are recognized and accredited worldwide, and are offered entirely online. You can join our distance learning programs from anywhere, at any time, while getting the support you need from our career and academic experts. Build your studies to fit your schedule: you can study full-time or part-time."
				}
			},
			"tablist": {
				"title": "Programs",
				"bachelor": {
					"label": "Bachelor"
				},
				"master": {
					"label": "Master"
				},
				"mba": {
					"label": "MBA"
				},
				"all_program": {
					"label": "Bachelor, Master & MBA"
				},
				"program": {
					"label": "Discover all the degrees"
				}
			},
			"moustache": {
				"title": "One Million African Talents is open for applications from August 11 to November 30 !",
				"link": {
					"title": "Get your Scholarship"
				}
			},
			"button": {
				"howto": {
					"label": "How to get involved",
					"to": "https://drive.google.com/file/d/1JKDJeVGGNNDYlazVEei2zZjs4b3-skMX/view"
				},
				"apply": {
					"label": "Apply now"
				},
				"viewall": {
					"label": "View progam details"
				}
			}
		},
		"insight": {
			"scholarships-count": {
				"label": "100 000"
			},
			"countries-count": {
				"label": 54
			},
			"cursus-count": {
				"label": "50{{caracter}}"
			},
			"courses-count": {
				"label": "100{{caracter}}"
			},
			"scholarships": {
				"label": "scholarships"
			},
			"countries": {
				"label": "african countries"
			},
			"cursus": {
				"label": "curriculums available"
			},
			"courses": {
				"label": "online courses"
			}
		},
		"poppin": {
			"basics": {
				"label": "Before applying",
				"description": "You are applying for a scholarship to study online and earn a degree at a leading European university. Here are some requirements to consider: ",
				"l1": "Verify that you can prove your identity, address and city of residence",
				"l2": "You can prove that you have a sufficient level of English language skills to take courses taught in English",
				"l3": "Prepare your tabular CV (in English)",
				"l4": "Have your transcripts and most recent degree available (to submit copies)"
			},
			"eligible": {
				"label": "Are you eligible ?",
				"description": "To be eligible for the OMAT program you must meet the conditions below :",
				"l1": "Be a citizen of an African country",
				"l2": "Be a resident of an African country",
				"l3": "Not being able to finance the higher education studies for which you are applying"
			},
			"reminder": {
				"label": "Reminder",
				"description": "Scholarships are for full-time studies and only cover the standard period of study, you will be able to choose a start date where you are really available to study ~30h/week !"
			},
			"rules": {
				"label1": "I agree the ",
				"label2": "rules of the challenge"
			},
			"news": {
				"label": "I agree to receive more information about the program"
			},
			"button": {
				"signin": {
					"label": "Login and apply"
				}
			}
		},
		"pub": {
			"title": "Apply now to get your Scholarship to attend an international degree !"
		},
		"sheet": {
			"card": {
				"title": "Welcome to your application sheet ,",
				"admin-title": "Welcome to your application sheet of,"
			}
		}
	},
	"application": {
		"space": {
			"label": "Application space."
		},
		"status": {
			"label": "Status",
			"NOT_COMPLETED": "Not completed",
			"COMPLETED": "Completed",
			"PENDING_VALIDATION": "Pending validation",
			"APPROVED": "Not completed",
			"DECLINED": "Pending validation",
			"SCHOLARSHIP_GRANTED": "Scholarship granted",
			"STUDY_IN_PROGRESS": "Study in progress",
			"STUDY_FINISHED": "Study finished"
		},
		"form": {
			"label": "Application form",
			"description": "Please fill out the form below, all fields are required.",
			"firstname": {
				"label": "First Name",
				"placeholder": "Add your first name"
			},
			"familyname": {
				"label": "Your family name",
				"placeholder": "Add your family name"
			},
			"date_birth": {
				"label": "Date of birth",
				"placeholder": "Add your date of birth"
			},
			"country_residence": {
				"label": "Country of residence",
				"placeholder": "Add your country of residence",
				"tooltip": "Scholarships available only to African residents"
			},
			"nationality": {
				"label": "Nationality",
				"placeholder": "Add your country",
				"tooltip": "Scholarships available for citizen of African countries"
			},
			"phone_number": {
				"label": "WhatsApp phone number",
				"placeholder": "+221770000000'"
			},
			"email": {
				"label": "Email",
				"placeholder": "Add your email address",
				"tooltip": "We will use your Jaangal email account"
			},
			"degree_level": {
				"label": "Level program",
				"placeholder": "Choose a degree level",
				"tooltip": "Check your eligibility before chosing you degree level"
			},
			"degree_program": {
				"label": "Study program",
				"placeholder": "Choose a study program",
				"tooltip": "Details on iu.org"
			},
			"credit_points": {
				"label": "Credit points (ECTS)",
				"placeholder": "Credit points (ECTS)",
				"tooltip": "Depending on the program you choose"
			},
			"desired_date": {
				"label": "Desired start date",
				"placeholder": "Choose a desired start date",
				"tooltip": "Choose a date that fits your agenda"
			},
			"identity": {
				"label": "Proof of identity (ID card or Passport)",
				"placeholder": "Upload your proof of identity here",
				"tooltip": "Identity Card or Passport"
			},
			"residency": {
				"label": "Proof of residency",
				"placeholder": "Upload your proof of residency here",
				"tooltip": "Residency certificate from local police station, official letter, internet bill with your address or similar"
			},
			"diploma": {
				"label": "Copy of your highest diploma obtained",
				"placeholder": "Upload a copy of your highest degree here"
			},
			"transcript_diploma": {
				"label": "Transcript of record (Certified English translation)",
				"placeholder": "Upload a transcript of record for your diploma",
				"tooltip": "Only for diploma in others languages"
			},
			"work_certificate": {
				"label": "Work certificate for related Master’s/MBA",
				"placeholder": "Upload your work certificate "
			},
			"work_certificate_template_file": {
				"label": "Download the work certificate template"
			},
			"related_degrees_file": {
				"label": "See related degrees list"
			},
			"resume": {
				"label": "Resume (tabular CV)",
				"placeholder": "Upload your resumé here",
				"tooltip": "Your resumé must be written in English"
			},
			"english_certificate": {
				"checkbox": "I certify that I have at least a B2 level in english",
				"placeholder": "Add an english level certificate (optional)",
				"label": "English level",
				"tooltip": "If you do not have an English language certificate, you may need to attend an free English language course before you can start the program."
			},
			"financial_declaration": {
				"label": "Self declaration for financial need",
				"placeholder": "Upload your self-declaration for financial need here",
				"tooltip": "You must use the downloadable template, sign it and upload it here "
			},
			"video_story": {
				"infos": {
					"FORMAT_AND_QUALITY": {
						"title": "A - FORMAT AND QUALITY",
						"INFO_ONE": "The video-story must be in full landscape 16:9 format for a duration between 15 seconds and 1 minute. It must not exceed the size of 250 Mb.",
						"INFO_TWO": "Candidates must find the best possible decor (indoor or outdoor) for a good quality of their video-story and use natural lighting and make sure to have good sound quality",
						"INFO_THREE": "Activate your microphone",
						"INFO_FOURTH": "Avoid echoes and surrounding noise"
					},
					"CONTENT": {
						"title": "B - CONTENT",
						"INFO_ONE": "The candidate must introduce himself by stating his identity and his level of study.",
						"INFO_TWO": "He must also talk about his study and professional project",
						"INFO_THREE": "He must then talk about his motivation",
						"INFO_FOURTH": "And finally invite his community to vote for him",
						"INFO_FIFTH": "The languages ​​selected are French and English"
					}
				},
				"label": "Story video",
				"placeholder": "Upload your video here",
				"tooltip": "Check your video format and size before uploading"
			},
			"template_file": {
				"label": "Download the template to be signed"
			},
			"video_sample": {
				"label": "See an example"
			},
			"upload_file": {
				"requirement": "Your file cannot exceed {{fileSize}}Mb and has to be in those formats"
			},
			"button_next": {
				"label": "Next"
			},
			"button_previous": {
				"label": "Previous"
			},
			"button_finish": {
				"label": "Finish"
			},
			"button_save": {
				"label": "Save my progress"
			},
			"reminder": "Reminder"
		},
		"step": {
			"study_choices": {
				"title": "Your study choice",
				"description": "In this section you will give your choice of studies among the list proposed by the IU university. \nOnly one choice is possible, so take the time to read the documentations to request the course of study that best fits your profile and expectations."
			},
			"personal_informations": {
				"title": "Your personnal informations",
				"description": "Please fill out the form below, all fields are required."
			},
			"upload_documents": {
				"title": "Your supporting documents",
				"description": "To complete your application, you must upload all the necessary supporting documents in this space. \nYou can do it in several times, don't forget to register your progress. "
			},
			"video_story": {
				"title": "Your video story",
				"description": "Last but not least, you will now have to upload the video of your talent here. "
			},
			"summary": {
				"title": "Summary",
				"description": "Application sheet"
			}
		},
		"sheet": {
			"diploma": {
				"label": "Highest diploma obtained"
			},
			"transcript_diploma": {
				"label": "Transcript of record (Certified English translation)"
			},
			"work_certificate": {
				"label": "Work certificate"
			},
			"fullname": {
				"label": "Full Name"
			},
			"birthday": {
				"label": "Birthday"
			},
			"country": {
				"label": "Country"
			},
			"desired_date": {
				"label": "Start date"
			},
			"level": {
				"label": "Level"
			},
			"program": {
				"label": "Study program"
			},
			"card": {
				"title": "One Million African Talents",
				"name_label": "Welcome to your application sheet"
			},
			"english_certificate": {
				"label": "English level certificate"
			}
		},
		"success": {
			"label": "Congratulations !",
			"message": "You have successfully completed your application area. Watch your notifications for the status of your application.",
			"share_link": {
				"label": "Share your profile to invite your friends to vote for you !"
			},
			"share_social": {
				"label": "Share on {{name}}"
			}
		},
		"succes": {
			"copy_link": {
				"label": "Copy link"
			},
			"share_video": {
				"title": "Generate a post automatically to invite your subscribers to support you",
				"button": "publish my video",
				"toast": "Your video has been published."
			}
		},
		"toast": {
			"save": {
				"title": "Saved",
				"message": "Your progress has been saved",
				"error": "An error occurred while saving"
			}
		},
		"save_button": "Finish",
		"save_draft_button": "Save my progress",
		"button": {
			"start_title": "Apply now",
			"continous_title": "Continue",
			"terminate_title": "See my application"
		},
		"partnership": {
			"label": "In partnership with"
		}
	},
	"vote": {
		"baseline": {
			"label": "I'm an african talent"
		},
		"counter": {
			"single": {
				"label": "{{total}} vote"
			},
			"label": "{{total}} votes"
		},
		"button": {
			"share": {
				"label": "Share"
			},
			"vote": {
				"label": "Vote"
			}
		},
		"share": {
			"my-profile": {
				"message": "Help me get a scholarship to continue my higher education. Vote now on my Jaangal profile!"
			},
			"profile": {
				"message": "Help {{name}} get a scholarship so he can continue his higher education. Vote now on his Jaangal profile!"
			}
		},
		"popin": {
			"share": {
				"label": "Share this profile"
			},
			"copylink": {
				"label": "Copy link"
			}
		},
		"success_toast": {
			"title": "Vote taken in account",
			"message": "Thanks ! You can vote once per day"
		}
	}
}
